/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddCategoryTagRequest {
  category_id?: string;
  tag_name?: string;
}

export interface AdditionalOptionsInstoreSearch {
  enabled?: boolean;
  /** @format int32 */
  locations_limit?: number;
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface AdjustCategoryLabelsOrderRequest {
  category_id?: string;
  labels_ids?: string[];
}

export interface AdjustCategoryLabelsOrderResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface AdjustDeliveryAddonsOrderRequest {
  addon_ids?: string[];
  category_id?: string;
}

export interface AdjustDeliveryAddonsOrderResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

export interface BookingMethod {
  carrier?: string;
  custom?: boolean;
  delivery_types?: DeliveryType[];
  id?: string;
  name?: string;
  /**  - NONE: None indicates that parcels are not available for shipping method. */
  parcel_type?: ParcelType;
}

/** CarrierDbsSettings represents a configuration for carrier-dbs service. */
export interface CarrierDbsSettings {
  /** ApiCustomerId represent "customerId" in the API requests. */
  api_customer_id?: string;
  /** ApiKey represent "key" in the API requests. */
  api_key?: string;
  /** GoodsDescription represent a default value for FTX FREE TEXT AAA section in EDI file */
  goods_description?: string;
  /** HeaderMerchantId is an identifier of merchant placed in the EDI header. */
  header_merchant_id?: string;
  /** MerchantId is a number a merchant is identified by in DBS systems. */
  merchant_id?: string;
  /** MerchantName is a merchant name used as its identifier in EDI. */
  merchant_name?: string;
  validation?: CarrierDbsSettingsValidationSettings;
}

export interface CarrierDbsSettingsValidationSettings {
  postal_code?: ValidationSettingsPostalCodeValidationSettings;
}

/** CarrierDhlExpressSettings represents a configuration for DHL Express in carrier-dhl. */
export interface CarrierDhlExpressSettings {
  account_number?: string;
  password?: string;
  /** API credentials */
  site_id?: string;
  /** Supports represent a set of delivery features that should be supported by shipping method. */
  supports?: CarrierDhlSettingsSupports;
}

/** CarrierDhlFreightSettings represents a configuration for DHL Freight in carrier-dhl. */
export interface CarrierDhlFreightSettings {
  /** Supports represent a set of delivery features that should be supported by shipping method. */
  supports?: CarrierDhlSettingsSupports;
  timetable_password?: string;
  /** Timetable API credentials */
  timetable_username?: string;
}

export interface CarrierDhlSettingsSupports {
  courier_instructions?: boolean;
  door_code?: boolean;
  search?: boolean;
}

export interface CarrierGenericSettings {
  /** GS1 CompanyId is the identifier of the company in the package identifier, it comes right after the extension digit. */
  gs1_company_id?: string;
  /** GS1 Prefix is referred to as "extension digit" and it's the first digit of the package identifier. */
  gs1_prefix?: string;
}

/** CarrierPnlSettings represents a configuration for carrier-pnl service. */
export interface CarrierPnlSettings {
  /** Adds externalID to edi reference field. */
  add_external_id_to_edi?: boolean;
  /**
   * AgreementCountry is a value passed to PostNord API to get pickup points
   * outside Nordics.
   */
  agreement_country?: string;
  /** ApiToken is the token used to make requests to PostNord API. */
  api_token?: string;
  /** PNL application info. */
  application_id?: string;
  application_name?: string;
  application_version?: string;
  /**
   * Adds externalID to edi reference field.
   * ConsignorName if set is used in place of from address name
   */
  consignor_name?: string;
  /** CustomerNumber is the merchant's identifier in the PostNord's systems. */
  customer_number?: string;
  /**
   * CustomerNumberIssuer is a code representing the entity which the customer
   * has a contract with thus issuing the customer number. (DK = 11, SE = 12, NO
   * = 13, FI = 14).
   */
  customer_number_issuer?: string;
  gs1_sscc_credentials?: GS1SsccCredentialsWrapper;
  package_type_code?: string;
  /** Print externalID content on PNL labels in reference section */
  print_reference?: boolean;
  /**
   * SenderId represent "REC" value in the booking XML file sent to PostNord's
   * FTP server.
   */
  recipient_id?: string;
  /**
   * SenderId represent "RECROUT" value in the booking XML file sent to
   * PostNord's FTP server.
   */
  recipient_route?: string;
  /**
   * SenderId represent "RECKVAL" value in the booking XML file sent to
   * PostNord's FTP server.
   */
  recipient_value?: string;
  /**
   * SenderId represent "SND" value in the booking XML file sent to PostNord's
   * FTP server.
   */
  sender_id?: string;
  /**
   * SenderId represent "SNDKVAL" value in the booking XML file sent to
   * PostNord's FTP server.
   */
  sender_value?: string;
  /**
   * ServicePointsCount is the maximum number of service points to be
   * loaded from the API when fetching shipping options.
   * @format uint64
   */
  service_points_count?: number;
  /**
   * Supports represent a set of delivery features that should be supported by
   * shipping method.
   */
  supports?: CarrierPnlSettingsSupportsWrapper;
  /** TrackingCustomerIds is the list of customer IDs */
  tracking_customer_ids?: string[];
  /** Use API booking instead of sending EDI/XML files. */
  use_api_booking?: boolean;
}

export interface CarrierPnlSettingsSupports {
  courier_instructions?: boolean;
  door_code?: boolean;
  search?: boolean;
}

export interface CarrierPnlSettingsSupportsWrapper {
  carrier_pnl_settings_supports?: CarrierPnlSettingsSupports;
}

export interface CarrierProduct {
  /** Carrier name (ex. "PNL", "DHL"). */
  carrier?: string;
  /** Internal carrier product ID. */
  id?: string;
  /** Carrier product name (ex. "MyPack Collect"). */
  product?: string;
}

export interface CarrierProductMapping {
  /** decides wether tracking link should be used instead of carrier events. */
  always_show_tracking_links?: boolean;
  carrier_product_carrier?: string;
  /** carrier_product_id allows to map carrier_product_ref with internally defined carrier products. */
  carrier_product_id?: string;
  carrier_product_name?: string;
  carrier_product_ref?: string;
  /** custom - if set to true, merchant have to provide tracking urls. */
  custom?: boolean;
  id?: string;
  tracking_config_status?: TrackingConfigStatus;
  /** tracking_links contains localized tracking urls. */
  tracking_links?: Record<string, string>;
}

export interface CarrierProductSettings {
  always_show_tracking_links?: boolean;
  carrier_product_carrier?: string;
  carrier_product_id?: string;
  carrier_product_name?: string;
  /** Setting 'custom' to true implies that tracking URLs must be provided. */
  custom?: boolean;
  tracking_config_status?: TrackingConfigStatus;
  /** Locale to tracking URL map. */
  tracking_links?: Record<string, string>;
}

/** CarrierTmrSettings represents a configuration for carrier-tmr service. */
export interface CarrierTmrSettings {
  api_endpoint?: string;
  api_token?: string;
}

/** CarrierTntSettings represents a configuration for carrier-tnt service. */
export interface CarrierTntSettings {
  /** Company account upon which collection is to be booked/rated. */
  account?: string;
  /** Update sort code when generating label. */
  adjust_sort_code_on_label?: boolean;
  /**
   * This element allows to state what should be done with the data passed in call to TNT.
   * If book is set to true the activity type will be BOOK, otherwise it will be SHIP.
   */
  book?: boolean;
  /** Company Name that must match up with the name registered against TNT account. */
  name?: string;
  /** Company Password. */
  password?: string;
}

export interface CategoryCountrySettings {
  category_id?: string;
  /** @format int32 */
  preselection_order?: number;
  use_for_fallback?: boolean;
}

export interface CategoryList {
  categories?: string[];
}

export interface ChannelsProperties {
  email_properties?: EmailChannelProperties;
  sms_properties?: SmsChannelProperties;
}

export interface CheckoutGroupPriceRule {
  /** @format int32 */
  price?: number;
  type?: CheckoutGroupPriceRuleType;
}

/** @default "RULE_UNSPECIFIED" */
export type CheckoutGroupPriceRuleType = "RULE_UNSPECIFIED" | "RULE_REDUCE_PRICE_WHEN_MORE_EXPENSIVE_PRODUCT_SELECTED";

export interface Command {
  add_category_tag_request?: AddCategoryTagRequest;
  adjust_category_labels_order_request?: AdjustCategoryLabelsOrderRequest;
  adjust_delivery_addons_order_request?: AdjustDeliveryAddonsOrderRequest;
  configure_internal_event_type_request?: ConfigureInternalEventTypeRequest;
  configure_shipping_method?: ConfigureShippingMethodRequest;
  create_carrier_product_mapping_request?: CreateCarrierProductMappingRequest;
  create_category_label_request?: CreateCategoryLabelRequest;
  create_category_request?: CreateCategoryRequest;
  create_delivery_addon_request?: CreateDeliveryAddonRequest;
  create_delivery_upsell_widget_country_configuration_request?: CreateDeliveryUpsellWidgetCountryConfigurationRequest;
  create_region_product_request?: CreateRegionProductRequest;
  create_region_request?: CreateRegionRequest;
  create_service_configuration_request?: CreateServiceConfigurationRequest;
  create_warehouse_cutoff_times_request?: CreateWarehouseCutoffTimesRequest;
  create_warehouse_request?: CreateWarehouseRequest;
  create_widget_country_configuration_request?: CreateWidgetCountryConfigurationRequest;
  deactivate_shipping_method?: DeactivateShippingMethodRequest;
  delete_carrier_product_mapping_request?: DeleteCarrierProductMappingRequest;
  delete_category_label_request?: DeleteCategoryLabelRequest;
  delete_category_label_translation_request?: DeleteCategoryLabelTranslationRequest;
  delete_category_request?: DeleteCategoryRequest;
  delete_category_translations?: DeleteCategoryTranslationsRequest;
  delete_custom_event_type_request?: DeleteCustomEventTypeRequest;
  delete_custom_event_type_translation_request?: DeleteCustomEventTypeTranslationRequest;
  delete_delivery_addon_request?: DeleteDeliveryAddonRequest;
  delete_delivery_addon_translation_request?: DeleteDeliveryAddonTranslationRequest;
  delete_delivery_time_properties_translations_request?: DeleteDeliveryTimePropertiesTranslationsRequest;
  delete_delivery_upsell_widget_country_configuration_request?: DeleteDeliveryUpsellWidgetCountryConfigurationRequest;
  delete_faq_widget_country_configuration_request?: DeleteFaqWidgetCountryConfigurationRequest;
  delete_product_page_widget_country_configuration_request?: DeleteProductPageWidgetCountryConfigurationReqeust;
  delete_region_product_request?: DeleteRegionProductRequest;
  delete_region_request?: DeleteRegionRequest;
  delete_service_configuration_request?: DeleteServiceConfigurationRequest;
  delete_warehouse_cutoff_times_request?: DeleteWarehouseCutoffTimesRequest;
  delete_warehouse_request?: DeleteWarehouseRequest;
  delete_warehouse_shipping_date_adjustment_request?: DeleteWarehouseShippingDateAdjustmentRequest;
  delete_widget_country_configuration_request?: DeleteWidgetCountryConfigurationRequest;
  list_carrier_product_mapping_response?: ListCarrierProductMappingResponse;
  list_carrier_products_request?: ListCarrierProductsRequest;
  remove_category_tag_request?: RemoveCategoryTagRequest;
  set_warehouse_shipping_date_adjustment_request?: SetWarehouseShippingDateAdjustmentRequest;
  update_carrier_product_mapping_request?: UpdateCarrierProductMappingRequest;
  update_category_country_settings_request?: UpdateCategoryCountrySettingsRequest;
  update_category_delivery_time?: UpdateCategoryDeliveryTimeRequest;
  update_category_details?: UpdateCategoryDetailsRequest;
  update_category_filter_rules_request?: UpdateCategoryFilterRulesRequest;
  update_category_label_request?: UpdateCategoryLabelRequest;
  update_category_translations?: UpdateCategoryTranslationsRequest;
  update_default_category_price?: UpdateDefaultCategoryPriceRequest;
  update_delivery_addon_request?: UpdateDeliveryAddonRequest;
  update_delivery_time_properties_translations_request?: UpdateDeliveryTimePropertiesTranslationsRequest;
  update_delivery_upsell_widget_configuration_request?: UpdateDeliveryUpsellWidgetConfigurationRequest;
  update_delivery_upsell_widget_country_configuration_request?: UpdateDeliveryUpsellWidgetCountryConfigurationRequest;
  update_faq_widget_default_configuration_request?: UpdateFaqWidgetDefaultConfigurationRequest;
  update_product_page_widget_default_configuration_request?: UpdateProductPageWidgetDefaultConfigurationRequest;
  update_receipt_widget_default_configuration_request?: UpdateReceiptWidgetDefaultConfigurationRequest;
  update_region_details?: UpdateRegionDetailsRequest;
  update_region_product?: UpdateRegionProductRequest;
  update_region_product_filter_rules_request?: UpdateRegionProductFilerRulesRequest;
  update_region_product_price_rules_request?: UpdateRegionProductPriceRulesRequest;
  update_service_configuration_request?: UpdateServiceConfigurationRequest;
  update_warehouse_cutoff_times?: UpdateWarehouseCutoffTimesRequest;
  update_warehouse_details?: UpdateWarehouseDetailsRequest;
  update_widget_configuration_request?: UpdateWidgetConfigurationRequest;
  update_widget_country_configuration_request?: UpdateWidgetCountryConfigurationRequest;
  upsert_carrier_product_settings_request?: UpsertCarrierProductSettingsRequest;
  upsert_category_label_translation_request?: UpsertCategoryLabelTranslationRequest;
  upsert_custom_event_type_request?: UpsertCustomEventTypeRequest;
  upsert_custom_event_type_translation_request?: UpsertCustomEventTypeTranslationRequest;
  upsert_delivery_addon_translation_request?: UpsertDeliveryAddonTranslationRequest;
  upsert_faq_widget_country_configuration_request?: UpsertFaqWidgetCountryConfigurationRequest;
  upsert_product_page_widget_country_configuration_request?: UpsertProductPageWidgetCountryConfigurationRequest;
  upsert_receipt_widget_country_configuration_request?: UpsertReceiptWidgetCountryConfigurationRequest;
}

export interface CompositePriceRule {
  price_components?: PriceComponent[];
}

export interface CompositePriceRuleWrapper {
  composite_price_rule?: CompositePriceRule;
}

export interface Condition {
  requirement?: string;
}

export interface ConditionalSortingRulesSet {
  conditions?: Condition[];
  sorting_rules?: SortingRule[];
}

export interface ConfigureInternalEventTypeRequest {
  /**
   *  - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
   *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been registered in Ingrid system.
   *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
   *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
   *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
   *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
   *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
   *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
   *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
   *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
   *  - DELAYED: DELAYED indicates that the delivery is delayed but will resume at a later time.
   *  - RETURNED: RETURNED indicates that the delivery has been returned.
   *  - INFO: INFO indicates some custom event.
   *  - ERROR: ERROR indicates that some error occurred.
   *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
   *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
   *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
   *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
   *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
   *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
   *  - ARRIVED_AT_DISTRIBUTION_TERMINAL: ARRIVED_AT_DISTRIBUTION_TERMINAL indicates that the shipment has arrived to a distribution terminal and is waiting for final delivery
   *  - ON_HOLD: ON_HOLD indicates that the shipment is held up at the moment and some action is required.
   *  - RECEIVED_AT_PICKUP_POINT: RECEIVED_AT_PICKUP_POINT indicates that the package was put into a pickup locker.
   *  - DEPARTED_FROM_PICKUP_POINT: DEPARTED_FROM_PICKUP_POINT indicates that the package departed a pickup locker.
   *  - SHIPMENT_CANCELED: SHIPMENT_CANCELED indicates that a shipment has been canceled in SOM.
   *  - TRACKING_NUMBER_REGISTERED: TRACKING_NUMBER_REGISTERED indicates that the tracking number has been registered.
   *  - CUSTOM: CUSTOM indicates that event type was defined by external party.
   *  - LABEL_CREATED_BY_CARRIER: LABEL_CREATED_BY_CARRIER indicates that the label was created by carrier.
   *  - PICKUP_FAILED: PICKUP_FAILED indicates that the carrier failed to pickup the parcel.
   *  - RETURN_PICKUP_SCHEDULED: RETURN_PICKUP_SCHEDULED indicates that a return pickup has been booked.
   *  - CARRIER_PRODUCT_ID_ASSIGNED: CARRIER_PRODUCT_ID_ASSIGNED indicates that an internal carrier product ID was assigned to the tracking entity.
   *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
   *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
   *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
   *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
   *  - DAMAGED: DAMAGED indicates that package has been damaged.
   *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
   *  - PICKUP_DELAYED: PICKUP_DELAYED means the carrier will try to pick up the shipment again
   * or that the sender has rescheduled the pick-up date for the shipment.
   *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
   *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
   *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
   *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
   *  - DELIVERY_PROMISE_EXCEEDED: DELIVERY_PROMISE_EXCEEDED status is deprecated in favour of ESTIMATED_DELIVERY_TIME_EXCEEDED.
   *  - ESTIMATED_DELIVERY_TIME_EXCEEDED: ESTIMATED_DELIVERY_TIME_EXCEEDED indicates that the current ETA has been exceeded.
   *  - ESTIMATED_DELIVERY_TIME_UPDATED: ESTIMATED_DELIVERY_TIME_UPDATED indicates that ETA has been updated.
   *  - ESTIMATED_SUBMISSION_TIME_EXCEEDED: ESTIMATED_SUBMISSION_TIME_EXCEEDED indicates that the package pickup from point of origin is delayed.
   *  - ESTIMATED_SUBMISSION_TIME_UPDATED: ESTIMATED_SUBMISSION_TIME_UPDATED indicates that ETS has been updated.
   *  - ORDER_RECEIPT_AVAILABLE: ORDER_RECEIPT_AVAILABLE indicates that the order receipt is available for the consumer.
   *  - ORDER_CONFIRMED_BY_MERCHANT: ORDER_CONFIRMED_BY_MERCHANT indicates that the order has been confirmed by merchant.
   *
   * deprecated in favour of ORDER_CANCELLED
   *  - ORDER_CANCELLED_BY_MERCHANT: ORDER_CANCELLED_BY_MERCHANT indicates that the order has been cancelled by merchant.
   *
   * deprecated in favour of ORDER_CANCELLED
   *  - ORDER_CANCELLED_BY_CUSTOMER: ORDER_CANCELLED_BY_CUSTOMER indicates that the order has been cancelled by customer.
   *  - ORDER_ITEMS_CANCELLED: ORDER_ITEMS_CANCELLED indicates that the delivery does not contain all items from original order.
   *  - RETURN_RECEIPT_AVAILABLE: RETURN_RECEIPT_AVAILABLE indicates that the return receipt is available for the consumer.
   *  - PREPARED: PREPARED indicates that the order items have been prepared by the merchant.
   *  - SUBMITTED: SUBMITTED indicates that the order items have been submitteds to carrier.
   *  - AWAITING_SUPPLIER: AWAITING_SUPPLIER indicates that the merchant is awaiting item delivery from their supplier.
   *  - LINEHAUL_TO_CARRIER: LINEHAUL_TO_CARRIER indicates that ordered items are being transported to carrier.
   *  - ESTIMATED_PREPARATION_TIME_EXCEEDED: ESTIMATED_PREPARATION_TIME_EXCEEDED indicates that order items are taking longer than promised to prepare.
   *  - ESTIMATED_PREPARATION_TIME_UPDATED: ESTIMATED_PREPARATION_TIME_UPDATED indicates that the preparation promise for order items has been updated.
   *  - CENTRA_ORDER_CONFIRMED: CENTRA_ORDER_CONFIRMED indicates that the order has been confirmed in Centra platform.
   *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
   * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
   *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
   *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
   *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
   *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
   * It's indicates RETURN direction.
   *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
   *  - PRICE_ADJUSTMENT_RECEIPT_AVAILABLE: PRICE_ADJUSTMENT_RECEIPT_AVAILABLE indicates that the price adjustment receipt is available for the consumer.
   *  - NOTIFICATION_TRIGGERED: NOTIFICATION_TRIGGERED indicates that a tracking notification has been triggered in the Ingrid Tracking system.
   *  - NOTIFICATION_DELIVERED: NOTIFICATION_DELIVERED indicates that a delivery notification has been successfully delivered to the customer.
   *  - NOTIFICATION_FAILED: NOTIFICATION_FAILED indicates that a delivery notification has been failed to reach the customer.
   *  - ORDER_RETURNED_IN_STORE: ORDER_RETURNED_IN_STORE indicates that the order has been returned in merchant's store.
   *
   * deprecated in favour of ORDER_RETURNED
   *  - ORDER_RETURNED_TO_WAREHOUSE: ORDER_RETURNED_IN_STORE indicates that the order has been returned to the merchant's warehouse.
   *
   * deprecated in favour of ORDER_RETURNED
   *  - PAYMENT_DECLINED: PAYMENT_DECLINED indicates that we got PaymentDeclined exception.
   *  - NOT_COLLECTED_BY_CUSTOMER: NOT_COLLECTED_BY_CUSTOMER indicates that package/order was not collected in the pickup point.
   *  - REMAINING_SHIPMENTS_CANCELLED: REMAINING_SHIPMENTS_CANCELLED see RemainingShipmentsCancelled message comment.
   *  - CENTRA_DELIVERY_GROUP_CANCELLED: CENTRA_DELIVERY_GROUP_CANCELLED indicates that the delivery group has been cancelled in centra.
   *  - PICKUP_REMINDER_TRIGGERED: PICKUP_REMINDER_TRIGGERED  indicated that a reminder to pick up a parcel was triggered.
   *  - ORDER_RETURNED: ORDER_RETURNED indicates that the order has been returned.
   *  - ORDER_CANCELLED: ORDER_CANCELLED indicates that the order has been cancelled.
   *  - RETURN_REQUESTED: RETURN_REQUESTED indicates that the return process has been requested by the customer or merchant.
   * Strictly in the RETURN direction parcel.
   *  - INSTORE_PARCEL_SEND_ACCEPTED: INSTORE_PARCEL_SEND_ACCEPTED indicates that parcel was accepted in the store, but it does not belong to any order.
   *  - READY_FOR_PICKUP: READY_FOR_PICKUP indicates that a parcel is ready to be collected in the pickup location,
   * whether a carrier-managed location such as a locker or in a merchant-owned store.
   *  - PICKED_UP_BY_CUSTOMER: PICKED_UP_BY_CUSTOMER indicates that a parcel was picked up from the pickup location,
   * whether a carrier-managed location such as a locker or in a merchant-owned store.
   */
  id?: Status;
  state?: State;
}

export interface ConfigureInternalEventTypeResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface ConfigureShippingMethodRequest {
  categories?: string[];
  /** CarrierDbsSettings represents a configuration for carrier-dbs service. */
  dbs_settings?: CarrierDbsSettings;
  delivery_types?: DeliveryType[];
  /** CarrierDhlExpressSettings represents a configuration for DHL Express in carrier-dhl. */
  dhl_express_settings?: CarrierDhlExpressSettings;
  /** CarrierDhlFreightSettings represents a configuration for DHL Freight in carrier-dhl. */
  dhl_freight_settings?: CarrierDhlFreightSettings;
  gnc_settings?: CarrierGenericSettings;
  id?: string;
  /** pnl_par_settings config is shared between pnl-par, pnl-par09, apnl-par12 and pnl-parexp. */
  pnl_settings?: CarrierPnlSettings;
  regions?: Region[];
  /** CarrierTmrSettings represents a configuration for carrier-tmr service. */
  tmr_settings?: CarrierTmrSettings;
  /** CarrierTntSettings represents a configuration for carrier-tnt service. */
  tnt_settings?: CarrierTntSettings;
}

export interface ConfigureShippingMethodResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface ContactData {
  email?: string;
  phone?: string;
}

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export interface CountryRegionConfig {
  excluded?: string[];
  included?: string[];
}

export interface CreateCarrierProductMappingRequest {
  always_show_tracking_links?: boolean;
  carrier_product_id?: string;
  carrier_product_ref?: string;
  custom?: boolean;
  tracking_links?: Record<string, string>;
}

export interface CreateCarrierProductMappingResponse {
  id?: string;
  /** @format int64 */
  version?: string;
}

export interface CreateCategoryLabelRequest {
  category_id?: string;
  color?: string;
  dark_mode_color?: string;
  icon?: string;
  name?: string;
  state?: State;
  type?: LabelType;
}

export interface CreateCategoryLabelResponse {
  label_id?: string;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateCategoryRequest {
  additional_options?: ShippingCategoryAdditionalOptions;
  custom_info_text?: string;
  custom_text?: string;
  custom_unavailable_text?: string;
  custom_warning_text?: string;
  delivery_time?: DeliveryTime;
  delivery_time_properties?: DeliveryTimeProperties;
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  external_id?: string;
  filter_rules?: FilterRule[];
  /** @format int32 */
  max_choices_count?: number;
  methods?: string[];
  name?: string;
  preselected?: boolean;
  region_ids?: string[];
  requirements?: ShippingCategoryRequirements;
  /** @format int32 */
  sort_order?: number;
  state?: State;
  time_formatting?: TimeFormatting;
}

export interface CreateCategoryResponse {
  category_id?: string;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateDeliveryAddonRequest {
  category_id?: string;
  defaults?: DeliveryAddonDefaults;
  external_id?: string;
  name?: string;
  price?: DeliveryAddonPrice;
  state?: State;
  /**
   *  - TYPE_CARRIER_DEFAULT: Default addons returned in FetchShippingOptions under default_addons field.
   * Default addons are not presented to end customer in UI (all other delivery addons are presented).
   *  - TYPE_ID_CHECK: Basic identity check – courier verifies recipient’s ID at delivery.
   *  - TYPE_WITHOUT_ID_CHECK: Basic identity check – courier will not verify recipient’s ID at delivery.
   *  - TYPE_DIGITAL_CHECK: Digital identity verification using BankID or similar.
   *  - TYPE_ID_MATCH_RECIPIENT: ID must match the name of the recipient (e.g. delivery only to person on label).
   *  - TYPE_AGE_CHECK: Basic age verification – courier confirms recipient meets age requirement (typically 18+).
   *  - TYPE_EXTENDED_AGE_CHECK: Extended age verification – includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_16: Age check requiring the recipient to be at least 16 years old.
   *  - TYPE_EXTENDED_AGE_CHECK_16: Extended age check for 16+ –  includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_18: Age check requiring the recipient to be at least 18 years old.
   *  - TYPE_EXTENDED_AGE_CHECK_18: Extended age check for 18+ – includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_20: Age check requiring the recipient to be at least 20 years old.
   *  - TYPE_AGE_CHECK_21: Age check requiring the recipient to be at least 21 years old.
   *  - TYPE_EMAIL: Notify recipient via email when shipment status is updated.
   *  - TYPE_SMS: Notify recipient via SMS when shipment status is updated.
   *  - TYPE_LETTER: Notify recipient via physical letter (paper notice, e.g., undeliverable or missed delivery).
   *  - TYPE_CALL: Notify recipient via phone call (automated or manual).
   *  - TYPE_NOTIFICATION: General or fallback notification without specifying the communication channel.
   *  - TYPE_PRE_EMAIL: Notify recipient via email before the shipment is dispatched or delivered (pre-alert).
   *  - TYPE_PRE_SMS: Notify recipient via SMS before the shipment is dispatched or delivered (pre-alert).
   *  - TYPE_PRE_CALL: Notify recipient via phone call before the shipment is dispatched or delivered.
   *  - TYPE_PRE_NOTIFICATION: General pre-notification without specifying channel (can be email, SMS, or call).
   *  - TYPE_WITHOUT_PRE_NOTIFICATION: Shipment proceeds without any pre-notification.
   *  - TYPE_LEAVE_AT_DOOR: Leave the parcel at the recipient’s door or in a designated safe place without requiring interaction.
   *  - TYPE_CARRY_IN: Courier is required to carry the parcel inside the recipient's home or building.
   *  - TYPE_CARRY_OUT: Courier is required to carry the parcel outside the recipient's home or building.
   *  - TYPE_HOME_DELIVERY: Deliver the parcel directly to the recipient’s home address instead of a pickup location or access point.
   *  - TYPE_ENDORSEMENT_ABANDON: Abandon the shipment if it cannot be delivered (no return or retry attempt).
   *  - TYPE_PERSONAL_DELIVERY: Deliver the parcel directly into the hands of the recipient; no drop-off allowed.
   *  - TYPE_INSTALLATION: Perform installation of the delivered item at the recipient's location (e.g., appliances or furniture).
   *  - TYPE_REMOVAL: Remove old items (e.g., used furniture or appliances) from the recipient’s location as part of the delivery service.
   *  - TYPE_RECYCLE: Collect old or used items from the recipient for recycling during the delivery process.
   *  - TYPE_SWAP: Collect old or used items from the recipient during the delivery process and swap with the delivery.
   *  - TYPE_DISABLE_MODIFICATIONS: Prevents the recipient from modifying delivery options, such as changing delivery location, time, or leave-at-door settings.
   *  - TYPE_OPTIONAL_SERVICE_POINT: Allows the recipient to change the pickup location or service point before delivery.
   *  - TYPE_FLEX_CHANGE: Allows the recipient to flexibly change the delivery method, time, or location while the shipment is in transit.
   *  - TYPE_UNWRAPPING: Perform unwrapping on delivered item at recipient's location.
   *  - TYPE_PICKUP_POINT_DELIVERY: Deliver the parcel directly to the pickup location or access point.
   *  - TYPE_MAILBOX_DELIVERY: Deliver the parcel directly to the mailbox directly.
   *  - TYPE_DELIVERY_BEFORE_8: Deliver the parcel before 8:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_9: Deliver the parcel before 9:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_10: Deliver the parcel before 10:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_12: Deliver the parcel before 12:00 PM (noon) on the scheduled delivery day.
   *  - TYPE_EVENING_DELIVERY: Deliver the parcel during the evening hours, typically after 5:00 PM.
   *  - TYPE_EXPRESS_DELIVERY: Prioritize the shipment for the fastest possible delivery, typically within 1–2 days depending on the carrier.
   *  - TYPE_PRIORITY_DELIVERY: Prioritize internal processing of the shipment to improve transit performance (carrier-defined).
   *  - TYPE_SATURDAY_DELIVERY: Deliver the parcel on a Saturday, even if it is outside standard weekday schedules.
   *  - TYPE_SUNDAY_DELIVERY: Deliver the parcel on a Sunday, if available within the carrier’s service area.
   *  - TYPE_SAME_DAY_DELIVERY: Deliver the parcel on the same day it is shipped, usually within a few hours.
   *  - TYPE_TIME_AGREED_DELIVERY: Delivery at a specific time window agreed between the sender and the carrier.
   *  - TYPE_BY_TRUCK: Shipment must be delivered using a truck, typically due to size, weight, or palletized load.
   *  - TYPE_PALLET_TRANSFER: EUR-pallet must be exchanged at the time of delivery.
   *  - TYPE_FRANKED_POSTAGE: Pre-paid postage method where the sender uses a franking machine or online portal to apply postage instead of stamps.
   *  - TYPE_CONTAINER_RENT: Temporary rental of a container or shipping unit required for the transport. Typically used for pallet shipments.
   *  - TYPE_LOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be loaded onto the vehicle at the pickup location.
   *  - TYPE_UNLOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be unloaded from the vehicle at the delivery location.
   *  - TYPE_THERMO_COLD: Shipment requires cold temperature handling (e.g., 2–8°C).
   *  - TYPE_THERMO_FROZEN: Shipment must be kept frozen throughout transport. (e.g., below 0°C)
   *  - TYPE_THERMO_WARM: Shipment must be kept warm or above a certain minimum temperature (e.g., 8–25°C).
   *  - TYPE_LONG_GOODS: Item is long or oversized, requiring special handling or space.
   *  - TYPE_PHARMACEUTICALS: Shipment contains pharmaceuticals and may require regulated handling.
   *  - TYPE_DANGEROUS_GOODS: Shipment contains hazardous materials and must comply with safety regulations.
   *  - TYPE_DANGEROUS_GOODS_LQ: Shipment contains a limited quantity of dangerous goods, exempt from full ADR handling.
   *  - TYPE_NON_STACKABLE: Parcel cannot be stacked during transport.
   *  - TYPE_POSTABLE: Parcel can fit directly into a mailbox.
   *  - TYPE_HANGING_GARMENT: Shipment contains garments that must remain hanging during transit.
   *  - TYPE_FRAGILE: Parcel is fragile and must be handled with extra care.
   *  - TYPE_ALCOHOL: Shipment contains alcohol and may require age verification or special handling.
   *  - TYPE_TYRES: Shipment contains tires, often bulky and requiring dedicated space or securing.
   *  - TYPE_NICOTINE: Shipment contains nicotine products and may require legal handling procedures.
   *  - TYPE_HEAVY: Indicates that the shipment is heavy and may require special handling or lifting equipment.
   *  - TYPE_COD: The recipient pays for the goods or shipping upon delivery (cash, card, or local method).
   *  - TYPE_SHIPPING_DISCOUNT: Applies a negotiated discount or subsidy to the shipping cost (usually requires prior agreement).
   *  - TYPE_RECIPIENT_PAYS: The recipient is responsible for covering the shipping cost, typically via invoice or contract with the carrier.
   *  - TYPE_KIND_QUANTITY: Specifies the type and quantity of items in the shipment (e.g., 3 boxes, 2 bottles); often required for customs or tariff purposes.
   *  - TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION: Enables shipment to be billed after delivery via invoice, with official invoice documentation provided.
   *  - TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION: Enables post-delivery billing on credit without requiring formal invoice documentation.
   *  - TYPE_INSURANCE: Provides coverage for loss or damage of the shipment, based on declared value or carrier-specific terms.
   *  - TYPE_TERMINAL_PICKUP: The shipment will not be delivered to the recipient's address but must be picked up from a designated terminal or depot.
   *  - TYPE_PERSONAL_PICKUP: Shipment must be collected in person by the recipient, typically with ID verification, from a post office, store, or pickup point.
   *  - TYPE_RETENTION_EXTENDED: Extends the retention period for the shipment at the pickup location, typically from 7 to 14 days.
   *  - TYPE_RETURN_TO_SENDER: Instructs the carrier to return the shipment to the sender if it cannot be delivered to the recipient.
   *  - TYPE_RETURN_QR_CODE: Allows the recipient to return the shipment using a scannable QR code instead of / along with printed return label.
   *  - TYPE_PRINT_RETURN_LABEL: Enables printing of the return label at a pickup location or drop-off point, instead of requiring the sender to print it in advance.
   *  - TYPE_CLIMATE_COMPENSATION: Offsets the carbon emissions of the shipment by contributing to certified environmental initiatives.
   *  - TYPE_SHIPMENT_CONSOLIDATION: Indicates that multiple shipments are merged into one consolidated delivery, typically for logistical or operational efficiency.
   *  - TYPE_SHIPMENT_MULTI_PARCELS: Indicates that the shipment consists of multiple parcels under a single tracking number or delivery order.
   *  - TYPE_HIDE_CUSTOMER_PHONE: Hides the recipient's phone number from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_HIDE_CUSTOMER_EMAIL: Hides the recipient's email address from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS: Passes the customer's name as part of delivery instructions, often used to override carrier restrictions or labels.
   *  - TYPE_RESIDENTIAL_ADDRESS_INDICATOR: Marks the delivery address as a residential location, which may affect handling or surcharges.
   *  - TYPE_SPLIT_SHIPMENT: Splits the shipment into multiple parcels or deliveries, typically due to size, weight, or inventory constraints.
   *  - TYPE_HIDE_CUSTOMER_DETAILS: Hides the customer details from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_SIGNATURE: Requires the recipient (or someone at the address) to sign for the shipment upon delivery.
   *  - TYPE_ADULT_SIGNATURE: Requires a legally recognized adult to sign for the shipment, often used for age-restricted deliveries.
   *  - TYPE_INDIRECT_SIGNATURE: Allows someone other than the primary recipient (e.g., neighbor or receptionist) to sign for the shipment.
   *  - TYPE_WITHOUT_POD: The carrier will deliver the package without collecting a signature or proof of delivery.
   *  - TYPE_SIGNATURE_PHOTO_POD: Captures a photo as proof of delivery, often showing the parcel at the drop-off location.
   *  - TYPE_EXTENDED_SIGNATURE_POD: Includes multiple proof of deliveries, such as a high-resolution image, signature, timestamp, and geolocation.
   */
  type?: Type;
}

export interface CreateDeliveryAddonResponse {
  addon_id?: string;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateDeliveryUpsellWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
  features?: DeliveryUpsellWidgetFeatures;
}

export interface CreateDeliveryUpsellWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateMerchantRequest {
  name?: string;
}

export interface CreateMerchantResponse {
  id?: string;
}

export interface CreateRegionProductRequest {
  composite_price_rule?: CompositePriceRule;
  delivery_time?: DeliveryTime;
  delivery_types?: DeliveryType[];
  external_method_id?: string;
  filter_rules?: FilterRule[];
  generate_default_shipping_options_on_error?: boolean;
  group_price_rule?: CheckoutGroupPriceRule[];
  method?: string;
  operating_schedule?: OperatingScheduleCarrierItem;
  price_rules?: PriceRule[];
  region_id?: string;
  shipping_date_adjustment?: ShippingDateAdjustment;
  supported_shipping_attributes?: string[];
}

export interface CreateRegionProductResponse {
  status?: CreateRegionProductResponseCreateRegionProductStatus;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

/** @default "CREATE_REGION_PRODUCT_STATUS_UNKNOWN" */
export type CreateRegionProductResponseCreateRegionProductStatus =
  | "CREATE_REGION_PRODUCT_STATUS_UNKNOWN"
  | "CREATE_REGION_PRODUCT_STATUS_CONFIGURED"
  | "CREATE_REGION_PRODUCT_STATUS_UNABLE_TO_CONFIGURE"
  | "CREATE_REGION_PRODUCT_STATUS_ALREADY_CONFIGURED";

export interface CreateRegionRequest {
  country_config?: CountryRegionConfig;
  currency?: string;
  group_id?: string;
  name?: string;
  postalcode_config?: PostalcodeRegionConfig;
  region_type?: string;
  state?: State;
  warehouse_id?: string;
}

export interface CreateRegionResponse {
  id?: string;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateServiceConfigurationRequest {
  configuration?: ServiceConfiguration;
  key?: string;
}

export interface CreateServiceConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateSiteRequest {
  merchant_id?: string;
  name?: string;
}

export interface CreateSiteResponse {
  id?: string;
}

export interface CreateWarehouseCutoffTimesRequest {
  carrier_cutoff?: boolean;
  cutoff_times?: Record<string, OperatingScheduleCutoffTimes>;
  method?: string;
  warehouse_id?: string;
}

export interface CreateWarehouseCutoffTimesResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateWarehouseRequest {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  state?: State;
  timezone?: string;
}

export interface CreateWarehouseResponse {
  id?: string;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CreateWidgetCountryConfigurationRequest {
  carrier_logos?: MethodList;
  /** The name of the country. [required] */
  country?: string;
  features?: Features;
  upfront_carriers?: MethodList;
}

export interface CreateWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface CutoffsItem {
  cutoff_times?: string[];
  day?: Day;
}

/** @default "UNKNOWN_DAY" */
export type Day = "UNKNOWN_DAY" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SAT" | "SUN";

export interface DeactivateShippingMethodRequest {
  category_ids?: string[];
  id?: string;
  region_ids?: string[];
}

export interface DeactivateShippingMethodResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteCarrierProductMappingRequest {
  id?: string;
}

export interface DeleteCarrierProductMappingResponse {
  /** @format int64 */
  version?: string;
}

export interface DeleteCategoryLabelRequest {
  category_id?: string;
  label_id?: string;
}

export interface DeleteCategoryLabelResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteCategoryLabelTranslationRequest {
  category_id?: string;
  label_id?: string;
  locale?: string;
}

export interface DeleteCategoryLabelTranslationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteCategoryRequest {
  category_id?: string;
}

export interface DeleteCategoryResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteCategoryTranslationsRequest {
  category_id?: string;
  locale?: string;
}

export interface DeleteCategoryTranslationsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteCustomEventTypeRequest {
  id?: string;
}

export interface DeleteCustomEventTypeResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteCustomEventTypeTranslationRequest {
  id?: string;
  locale?: string;
}

export interface DeleteCustomEventTypeTranslationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteDeliveryAddonRequest {
  addon_id?: string;
  category_id?: string;
}

export interface DeleteDeliveryAddonResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteDeliveryAddonTranslationRequest {
  addon_id?: string;
  category_id?: string;
  locale?: string;
}

export interface DeleteDeliveryAddonTranslationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteDeliveryTimePropertiesTranslationsRequest {
  /** Identifer of the category being deleted. [required] */
  category_id?: string;
  /** locale of which translations are to be removed. [required] */
  locale?: string;
}

export interface DeleteDeliveryTimePropertiesTranslationsResponse {
  /** @format int64 */
  version?: string;
}

export interface DeleteDeliveryUpsellWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
}

export interface DeleteDeliveryUpsellWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteFaqWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
}

export interface DeleteFaqWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteProductPageWidgetCountryConfigurationReqeust {
  /** The name of the country. [required] */
  country?: string;
}

export interface DeleteProductPageWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteRegionProductRequest {
  delivery_types?: DeliveryType[];
  method?: string;
  region_id?: string;
}

export interface DeleteRegionProductResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteRegionRequest {
  region_id?: string;
}

export interface DeleteRegionResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteServiceConfigurationRequest {
  key?: string;
}

export interface DeleteServiceConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteWarehouseCutoffTimesRequest {
  method?: string;
  warehouse_id?: string;
}

export interface DeleteWarehouseCutoffTimesResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteWarehouseRequest {
  id?: string;
}

export interface DeleteWarehouseResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteWarehouseShippingDateAdjustmentRequest {
  /** Identifier of the warehouse being edited. [required] */
  warehouse_id?: string;
}

export interface DeleteWarehouseShippingDateAdjustmentResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeleteWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
}

export interface DeleteWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface DeliveryAddonDefaults {
  selected?: boolean;
}

export interface DeliveryAddonPrice {
  value?: string;
  /** @format float */
  vat_rate?: number;
}

export interface DeliveryTime {
  /** @format int32 */
  max?: number;
  /** @format int32 */
  min?: number;
  unit?: string;
}

export interface DeliveryTimeProperties {
  custom_text?: string;
  format?: string;
  ignore_cutoffs?: boolean;
  keep_delivery_time_after_address?: boolean;
  range?: TimeFormatting;
  timespan?: DeliveryTimePropertiesTimespanWrapper;
  use_timespan?: boolean;
}

export interface DeliveryTimePropertiesTimespan {
  from?: string;
  to?: string;
}

export interface DeliveryTimePropertiesTimespanWrapper {
  delivery_time_properties_timespan?: DeliveryTimePropertiesTimespan;
}

export interface DeliveryTimePropertiesWrapper {
  delivery_time_properties?: DeliveryTimeProperties;
}

export interface DeliveryTimeWrapper {
  delivery_time?: DeliveryTime;
}

/**
 * Indicates the type of the delivery
 * - UNKNOWN: Delivery type is not known for some reason
 *  - DELIVERY: Home delivery
 *  - PICKUP: Delivery to a service point or a locker
 *  - MAILBOX: Delivery to customer's mailbox
 *  - INSTORE: Delivery to one of the merchants stores
 *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
 * @default "UNKNOWN"
 */
export type DeliveryType = "UNKNOWN" | "DELIVERY" | "PICKUP" | "MAILBOX" | "INSTORE" | "INWAREHOUSE";

export interface DeliveryUpsellWidgetConfiguration {
  by_country?: Record<string, DeliveryUpsellWidgetCountryConfiguration>;
  features?: DeliveryUpsellWidgetFeatures;
}

export interface DeliveryUpsellWidgetCountryConfiguration {
  features?: DeliveryUpsellWidgetFeatures;
}

export interface DeliveryUpsellWidgetFeatures {
  bar_color?: string;
  bar_color_success?: string;
  bar_visibility?: boolean;
  carrier_logos?: MethodList;
  custom_font_url?: string;
  disable_padding?: boolean;
  display_currency_iso_code?: boolean;
  enable_analytics?: boolean;
  enable_animation?: boolean;
  enable_bar_border_padding?: boolean;
  enable_bar_border_radius?: boolean;
  enable_free_shipping_indicator?: boolean;
  enable_free_shipping_indicator_category_name_message?: boolean;
  enable_icon?: boolean;
  enable_upfront_shipping_price?: boolean;
  enable_uppercase_text?: boolean;
  font_family?: string;
  /** @format int32 */
  font_size?: number;
  /** @format int32 */
  font_weight?: number;
  free_shipping_indicator_message?: DeliveryUpsellWidgetFeaturesFreeShippingIndicatorMessage;
  hide_free_text?: boolean;
  ignored_categories?: CategoryList;
  show_carrier_logos?: boolean;
}

/** @default "FREE_SHIPPING_INDICATOR_MESSAGE_UNKNOWN" */
export type DeliveryUpsellWidgetFeaturesFreeShippingIndicatorMessage =
  | "FREE_SHIPPING_INDICATOR_MESSAGE_UNKNOWN"
  | "FREE_SHIPPING_INDICATOR_MESSAGE_CATEGORY_NAME"
  | "FREE_SHIPPING_INDICATOR_MESSAGE_DELIVERY_TYPE"
  | "FREE_SHIPPING_INDICATOR_MESSAGE_BASIC";

export interface DeliveryUpsellWidgetFeaturesWrapper {
  features?: DeliveryUpsellWidgetFeatures;
}

/** @default "DEPRECATED_METHOD_VISIBILITY_UNKNOWN" */
export type DeprecatedMethodOnListingVisibility =
  | "DEPRECATED_METHOD_VISIBILITY_UNKNOWN"
  | "DEPRECATED_METHOD_VISIBILITY_INVISIBLE"
  | "DEPRECATED_METHOD_VISIBILITY_VISIBLE";

export interface EmailChannelProperties {
  enabled?: boolean;
  sender_address?: string;
  sender_name?: string;
}

export interface FTPPartialStatuses {
  carrier_status?: TrackingConfigStatus;
  last_external_event_status?: TrackingConfigStatus;
}

export interface FaqWidgetFeatures {
  accent_color_1?: string;
  alter_ics_delivery_message?: boolean;
  display_currency_iso_code?: boolean;
  enable_accent_color_for_widget_elements?: boolean;
  enable_country_selector?: boolean;
  enable_fx_converter?: boolean;
  enable_price_zero_value?: boolean;
  enable_widget_border?: boolean;
  ignored_categories?: string[];
  make_widget_transparent?: boolean;
  show_carrier_icons?: boolean;
  show_currency_before_price?: boolean;
  show_delivery_times_as_estimates?: boolean;
}

export interface Features {
  alter_ics_delivery_message?: boolean;
  autocomplete_street?: boolean;
  dark_color_enabled?: boolean;
  disable_address_form?: boolean;
  disable_choice_lost_modal_if_similar_selected?: boolean;
  display_currency_iso_code?: boolean;
  display_location_type?: boolean;
  display_upfront_address?: boolean;
  /** Use require_street_on_address_module instead. [deprecated] */
  dont_require_street_on_address_fields?: boolean;
  door_code?: boolean;
  enable_accent_color_for_widget_elements?: boolean;
  enable_addon_new_presentation?: boolean;
  enable_analytics?: boolean;
  enable_country_input_placeholder?: boolean;
  enable_country_selector?: boolean;
  enable_free_shipping_indicator?: boolean;
  enable_free_shipping_indicator_carrier_logo?: boolean;
  enable_free_shipping_indicator_category_name_message?: boolean;
  enable_high_contrast?: boolean;
  enable_ingrid_logo?: boolean;
  enable_multiple_home_delivery_in_category?: boolean;
  enable_postal_code_in_location_address?: boolean;
  enable_price_zero_value?: boolean;
  enable_short_delivery_times?: boolean;
  enable_transparent_background?: boolean;
  enable_widget_border?: boolean;
  /** Use show_street_on_address_module instead. [deprecated] */
  hide_street_on_address_fields?: boolean;
  hide_toc?: boolean;
  new_search_address?: boolean;
  require_region?: boolean;
  require_street_on_address_module?: boolean;
  /**
   * Value 0 indicates that shipping categories folding is disabled.
   * @format int64
   */
  shipping_categories_visible_when_folded_count?: number;
  show_base_price?: boolean;
  show_billing_address?: boolean;
  show_cancel_button_on_modal?: boolean;
  show_carrier_icons?: boolean;
  show_carrier_logos_in_shipping_categories_placeholder?: boolean;
  /** Use show_city_on_address_module instead. [deprecated] */
  show_city_on_address_fields?: boolean;
  show_city_on_address_module?: boolean;
  show_currency_before_price?: boolean;
  show_delivered_by?: boolean;
  show_delivery_times_as_estimates?: boolean;
  show_map?: boolean;
  show_privacy_policy?: boolean;
  show_region?: boolean;
  show_shipping_categories_before_address?: boolean;
  show_shipping_options_header?: boolean;
  show_shipping_price_on_service_points_view?: boolean;
  show_slogan?: boolean;
  show_state_on_address_fields?: boolean;
  show_street_on_address_module?: boolean;
}

export interface FeaturesWrapper {
  features?: Features;
}

export interface FilterRule {
  condition?: string;
}

export interface GS1SsccCredentials {
  /**
   * CompanyId is the identifier of the company in the package identifier, it
   * comes right after the extension digit.
   * @format int64
   */
  company_id?: number;
  /**
   * Prefix is referred to as "extension digit" and it's the first digit of the
   * package identifier.
   * @format int64
   */
  prefix?: number;
}

export interface GS1SsccCredentialsWrapper {
  gs1_sscc_credentials?: GS1SsccCredentials;
}

export interface GetShippingMethodConfigurationResponse {
  shipping_method_configuration?: ShippingMethodConfiguration;
}

export interface GetShippingMethodResponse {
  shipping_method?: ShippingMethod;
}

export interface GetTrackingConfigStatusResponse {
  always_show_tracking_links?: boolean;
  tracking_configuration_status?: TrackingConfigurationStatus;
}

/** @default "LABEL_TYPE_UNKNOWN" */
export type LabelType =
  | "LABEL_TYPE_UNKNOWN"
  | "LABEL_TYPE_SUSTAINABILITY"
  | "LABEL_TYPE_PRIORITY"
  | "LABEL_TYPE_CUSTOM"
  | "LABEL_TYPE_SWAN";

export interface ListCarrierProductMappingResponse {
  carrier_product_mappings?: CarrierProductMapping[];
  /** @format int64 */
  version?: string;
}

export interface ListCarrierProductSettingsResponse {
  carrier_product_settings?: CarrierProductSettings[];
  /** @format int64 */
  version?: string;
}

export type ListCarrierProductsRequest = object;

export interface ListCarrierProductsResponse {
  carrier_products?: CarrierProduct[];
}

export interface ListCategoriesResponse {
  categories?: ShippingCategory[];
}

export interface ListConfigurableShippingMethodsResponse {
  shipping_methods?: ShippingMethod[];
}

export interface ListConfigurationChangesResponse {
  changes?: ListConfigurationChangesResponseChange[];
}

export interface ListConfigurationChangesResponseChange {
  command?: Command;
  updated_at?: string;
  user_id?: string;
}

export interface ListConfiguredBookingMethodsResponse {
  methods?: BookingMethod[];
}

export interface ListConfiguredShippingMethodsResponse {
  shipping_methods?: ShippingMethod[];
}

export interface ListProgressNotificationSettingsResponse {
  channels_properties: ChannelsProperties;
  enabled?: boolean;
  progress_notifications_settings: ProgressNotificationSettings[];
}

export interface ListRegionsResponse {
  regions?: Region[];
}

export interface ListShippingMethodsResponse {
  methods?: ShippingMethod[];
}

export interface ListSmartNotificationSettingsResponse {
  enabled?: boolean;
  pickup_reminder_settings: PickupReminderSettings;
}

export interface ListSortingRulesRequest {
  site_id?: string;
}

export interface ListSortingRulesResponse {
  sorting_rules?: SortingRule[];
}

export interface ListSuggestedCarrierProductMappingsResponse {
  /** List of product references that match existing product IDs. */
  automapped_carrier_product_refs?: ListSuggestedCarrierProductMappingsResponseSuggestedCarrierProductRef[];
  /** List of product references that have not been mapped to any existing product IDs. */
  unmapped_carrier_product_refs?: ListSuggestedCarrierProductMappingsResponseSuggestedCarrierProductRef[];
}

export interface ListSuggestedCarrierProductMappingsResponseSuggestedCarrierProductRef {
  always_show_tracking_links?: boolean;
  carrier_product_carrier?: string;
  carrier_product_id?: string;
  carrier_product_name?: string;
  carrier_product_ref?: string;
}

export interface ListTrackingLinksForCarrierProductResponse {
  tracking_links?: Record<string, string>;
}

export interface MetaField {
  deprecated?: boolean;
  description?: string;
  display_name?: string;
  key?: string;
}

/** @default "METHOD_BOOKING_STATUS_UNKNOWN" */
export type MethodBookingConfigStatus =
  | "METHOD_BOOKING_STATUS_UNKNOWN"
  | "METHOD_BOOKING_STATUS_UNAVAILABLE"
  | "METHOD_BOOKING_STATUS_AVAILABLE"
  | "METHOD_BOOKING_STATUS_CONFIGURED";

/** @default "METHOD_STATUS_UNKNOWN" */
export type MethodConfigStatus =
  | "METHOD_STATUS_UNKNOWN"
  | "METHOD_STATUS_NOT_CONFIGURED"
  | "METHOD_STATUS_CONFIGURED"
  | "METHOD_STATUS_CONFIGURED_ONLY_FOR_BOOKING";

export interface MethodList {
  methods?: string[];
}

export interface MethodListWrapper {
  methods?: MethodList;
}

/** @default "METHOD_SHIPPING_STATUS_UNKNOWN" */
export type MethodShippingConfigStatus =
  | "METHOD_SHIPPING_STATUS_UNKNOWN"
  | "METHOD_SHIPPING_STATUS_NOT_PRESENT"
  | "METHOD_SHIPPING_STATUS_PRESENT_NOT_CONFIGURED"
  | "METHOD_SHIPPING_STATUS_CONFIGURED"
  | "METHOD_SHIPPING_STATUS_UNAVAILABLE";

export interface NotificationChannelSettings {
  channel_type?: NotificationChannelType;
  enabled?: boolean;
}

/** @default "NOTIFICATION_CHANNEL_TYPE_UNSPECIFIED" */
export type NotificationChannelType =
  | "NOTIFICATION_CHANNEL_TYPE_UNSPECIFIED"
  | "NOTIFICATION_CHANNEL_TYPE_SMS"
  | "NOTIFICATION_CHANNEL_TYPE_EMAIL";

export interface OperatingScheduleCarrierItem {
  carrier_cutoff?: boolean;
  cutoffs_plan?: CutoffsItem[];
}

export interface OperatingScheduleCarrierItemWrapper {
  operating_schedule_item?: OperatingScheduleCarrierItem;
}

export interface OperatingScheduleCutoffTimes {
  times?: string[];
}

export interface OperatingScheduleException {
  cutoff_times?: string[];
  valid_from?: string;
  valid_until?: string;
}

/**
 *  - NONE: None indicates that parcels are not available for shipping method.
 * @default "PARCEL_TYPE_UNKNOWN"
 */
export type ParcelType = "PARCEL_TYPE_UNKNOWN" | "NONE" | "LETTER" | "PACKAGE" | "PALLET";

export interface PickupReminderSettings {
  channel_settings?: NotificationChannelSettings[];
  display_name?: string;
  /** @format int32 */
  threshold?: number;
}

export interface PollingPartialStauses {
  carrier_status?: TrackingConfigStatus;
  last_external_event_status?: TrackingConfigStatus;
  tat_status?: TrackingConfigStatus;
}

export interface PostalcodeRegionConfig {
  country?: string;
  excluded_postal_codes?: string[];
  postal_codes?: string[];
}

export interface PriceComponent {
  name?: string;
  value?: string;
}

export interface PriceRule {
  conditions?: string[];
  /** @format int32 */
  price?: number;
  valid_from?: string;
  valid_until?: string;
}

export interface ProductPageWidgetFeatures {
  accent_color?: string;
  alter_ics_delivery_message?: boolean;
  custom_font_family_name?: string;
  custom_font_family_url?: string;
  disable_ingrid_logo?: boolean;
  display_categories_without_postal_code?: boolean;
  enable_analytics?: boolean;
  enable_short_delivery_times?: boolean;
  /** @format int32 */
  font_size_primary?: number;
  /** @format int32 */
  font_size_secondary?: number;
  /** @format int32 */
  font_weight_default?: number;
  /** @format int32 */
  font_weight_stronger?: number;
  hide_carrier_logos_pre_categories?: boolean;
  neutral_color?: string;
  preserve_postal_code?: boolean;
  secondary_color?: string;
  /**
   * Value 0 indicates that shipping categories folding is disabled.
   * @format int64
   */
  shipping_categories_visible_when_folded_count?: number;
  show_delivery_times_as_estimates?: boolean;
}

export interface ProgressNotificationSettings {
  channel_settings?: NotificationChannelSettings[];
  tracking_step?: Step;
}

export interface PushingPartialStatuses {
  carrier_status?: TrackingConfigStatus;
  last_external_event_status?: TrackingConfigStatus;
}

export interface ReceiptWidgetFeatures {
  delivery?: ReceiptWidgetFeaturesDelivery;
  footer?: ReceiptWidgetFeaturesFooter;
  header?: ReceiptWidgetFeaturesSection;
  order_details?: ReceiptWidgetFeaturesSectionWithHeader;
  order_summary?: ReceiptWidgetFeaturesSectionWithHeader;
  rating?: ReceiptWidgetFeaturesSectionWithHeader;
}

export interface ReceiptWidgetFeaturesDelivery {
  enable_header?: boolean;
  enable_section?: boolean;
  is_courier_instructions_editable?: boolean;
  is_door_code_editable?: boolean;
}

export interface ReceiptWidgetFeaturesFooter {
  enable_ingrid_logo?: boolean;
  enable_section?: boolean;
  show_privacy_policy?: boolean;
  show_slogan?: boolean;
}

export interface ReceiptWidgetFeaturesSection {
  enable_section?: boolean;
}

export interface ReceiptWidgetFeaturesSectionWithHeader {
  enable_header?: boolean;
  enable_section?: boolean;
}

export interface Region {
  /** @format int32 */
  default_price?: number;
  id?: string;
  name?: string;
  operating_schedule?: OperatingScheduleCarrierItem;
}

export interface RegionFeatures {
  enable_country_selector?: boolean;
  enable_price_based_category_sorting?: boolean;
  show_high_demand_affects_delivery_disclaimer_message?: boolean;
}

export interface RemoveCategoryTagRequest {
  category_id?: string;
  tag_name?: string;
}

export interface RenameMerchantRequest {
  id?: string;
  name?: string;
}

export type RenameMerchantResponse = object;

export interface RenameSiteRequest {
  id?: string;
  name?: string;
}

export type RenameSiteResponse = object;

export interface ServiceConfiguration {
  /** CarrierPnlSettings represents a configuration for carrier-pnl service. */
  carrier_pnl_settings?: CarrierPnlSettings;
}

export interface SetWarehouseShippingDateAdjustmentRequest {
  /** Identifier of the method being edited. [required] */
  shipping_date_adjustment?: ShippingDateAdjustment;
  /** Identifier of the warehouse being edited. [required] */
  warehouse_id?: string;
}

export interface SetWarehouseShippingDateAdjustmentResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface ShippingCategory {
  id?: string;
  name?: string;
}

export interface ShippingCategoryAdditionalOptions {
  instore_search_options?: AdditionalOptionsInstoreSearch;
}

export interface ShippingCategoryRequirements {
  address?: boolean;
  customer_number?: boolean;
  enable_additional_location_info?: boolean;
  enable_choice_selection?: boolean;
  hide_shipping_options?: boolean;
  show_carrier_logos?: boolean;
  show_carrier_logos_on_map_pin?: boolean;
  use_price_from?: boolean;
}

export interface ShippingCategoryRequirementsWrapper {
  requirements?: ShippingCategoryRequirements;
}

export interface ShippingDateAdjustment {
  /** @format int32 */
  adjust_end?: number;
  /** @format int32 */
  adjust_start?: number;
  unit?: string;
}

export interface ShippingDateAdjustmentWrapper {
  shipping_date_adjustment?: ShippingDateAdjustment;
}

export interface ShippingMethod {
  /** AutoConfigurable determines if the default config for the method can be used. */
  auto_configurable?: boolean;
  booking_config_status?: MethodBookingConfigStatus;
  /** MetaFields lists additional flags, toggles, or implementation-specific properties that modify booking behavior. */
  booking_meta_fields?: MetaField[];
  carrier?: string;
  delivery_types?: DeliveryType[];
  deprecated_on_listing?: DeprecatedMethodOnListingVisibility;
  id?: string;
  /** is_consolidated_shipment_method if true then this shipping method may be used when booking consolidated shipments in Ingrid TA */
  is_consolidated_shipment_method?: boolean;
  name?: string;
  /**  - NONE: None indicates that parcels are not available for shipping method. */
  parcel_type?: ParcelType;
  /** Deprecated, selfConfigurable determines if this shipping method can be configured for site by user with proper permissions. [deprecated] */
  self_configurable?: boolean;
  shipping_config_status?: MethodShippingConfigStatus;
  /** MetaFields lists additional flags, toggles, or implementation-specific properties that modify checkout behavior. */
  shipping_meta_fields?: MetaField[];
  /** Deprecated, use MethodShippingConfigStatus instead. [deprecated] */
  status?: MethodConfigStatus;
}

export interface ShippingMethodConfiguration {
  carrier?: string;
  categories?: ShippingCategory[];
  /** CarrierDbsSettings represents a configuration for carrier-dbs service. */
  dbs_settings?: CarrierDbsSettings;
  delivery_types?: DeliveryType[];
  /** CarrierDhlExpressSettings represents a configuration for DHL Express in carrier-dhl. */
  dhl_express_settings?: CarrierDhlExpressSettings;
  /** CarrierDhlFreightSettings represents a configuration for DHL Freight in carrier-dhl. */
  dhl_freight_settings?: CarrierDhlFreightSettings;
  gnc_settings?: CarrierGenericSettings;
  id?: string;
  name?: string;
  /** CarrierPnlSettings represents a configuration for carrier-pnl service. */
  pnl_settings?: CarrierPnlSettings;
  regions?: Region[];
  /** CarrierTmrSettings represents a configuration for carrier-tmr service. */
  tmr_settings?: CarrierTmrSettings;
  /** CarrierTntSettings represents a configuration for carrier-tnt service. */
  tnt_settings?: CarrierTntSettings;
}

export interface ShippingOptionConfiguration {
  courier_instructions?: boolean;
  delivery_time_unit?: string;
  door_code?: boolean;
  searchable?: boolean;
}

export interface SmsChannelProperties {
  enabled?: boolean;
  sender_name?: string;
}

export type SortDrivingDist = object;

export interface SortDrivingDistanceThreshold {
  /** @format int32 */
  threshold?: number;
}

export type SortDrivingDuration = object;

export interface SortFavorCarrier {
  name?: string;
}

export interface SortFavorClosestFreeShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export interface SortFavorClosestShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export interface SortFavorClosestTimeDistanceFreeShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export interface SortFavorClosestTimeDistanceShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export type SortGeoDistance = object;

export type SortPrice = object;

export interface SortRespectCarrierLocationsOrder {
  /** If shipping_methods is set the SortRespectCarrierLocationsOrder will be applied only for particular shipping_method. */
  shipping_methods?: string[];
}

export type SortTimeSlot = object;

export type SortWalkingDist = object;

/**
 * SortWalkingDuration sorts choices based on walking duration. If either distance_threshold or duration_threshold is set,
 * it treats choices farther than the threshold as equal. If none of them is set, COS should use the default of distance_threshold = 1000.
 */
export interface SortWalkingDuration {
  /** @format int64 */
  distance_threshold?: string;
  /** @format int64 */
  duration_threshold?: string;
}

export interface SortingRule {
  conditional_sorting_rules_set?: ConditionalSortingRulesSet;
  driving_distance?: SortDrivingDist;
  driving_distance_threshold?: SortDrivingDistanceThreshold;
  favor_carrier?: SortFavorCarrier;
  favor_closest_free_shipping_option?: SortFavorClosestFreeShippingOption;
  favor_closest_shipping_option?: SortFavorClosestShippingOption;
  favor_closest_time_distance_free_shipping_option?: SortFavorClosestTimeDistanceFreeShippingOption;
  favor_closest_time_distance_shipping_option?: SortFavorClosestTimeDistanceShippingOption;
  lower_price?: SortPrice;
  sort_driving_duration?: SortDrivingDuration;
  sort_geo_distance?: SortGeoDistance;
  sort_respect_carrier_locations_order?: SortRespectCarrierLocationsOrder;
  /**
   * SortWalkingDuration sorts choices based on walking duration. If either distance_threshold or duration_threshold is set,
   * it treats choices farther than the threshold as equal. If none of them is set, COS should use the default of distance_threshold = 1000.
   */
  sort_walking_duration?: SortWalkingDuration;
  time_slot?: SortTimeSlot;
  walking_distance?: SortWalkingDist;
}

/** @default "UNKNOWN" */
export type State = "UNKNOWN" | "INACTIVE" | "ACTIVE";

/**
 *  - UNKNOWN: UNKNOWN indicates an unknown status which could not be harmonized.
 *  - ORDER_CREATED: ORDER_CREATED indicates that the order has been registered in Ingrid system.
 *  - ORDER_BOOKED: ORDER_BOOKED indicates that the order has been booked by the merchant.
 *  - PICKUP_BOOKING_SCHEDULED: PICKUP_BOOKING_SCHEDULED indicates that booking service will include the delivery in the next booking operation.
 *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the delivery has been successfully booked with the carrier.
 *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation to pickup point or in line haul.
 *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way to a customers home address.
 *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
 *  - DELIVERED: DELIVERED indicates that the delivery has been delivered to the customer.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - DELAYED: DELAYED indicates that the delivery is delayed but will resume at a later time.
 *  - RETURNED: RETURNED indicates that the delivery has been returned.
 *  - INFO: INFO indicates some custom event.
 *  - ERROR: ERROR indicates that some error occurred.
 *  - SHIPMENT_CREATED: SHIPMENT_CREATED indicates that a shipment has been created in SOM.
 *  - LOGISTIC_UNIT_CREATED: LOGISTIC_UNIT_CREATED indicates that a logistic unit / (parcel-delivery) has been created in SOM.
 *  - LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER: LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER indicates that a logistic unit has received a tracking number.
 *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
 *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
 *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
 *  - ARRIVED_AT_DISTRIBUTION_TERMINAL: ARRIVED_AT_DISTRIBUTION_TERMINAL indicates that the shipment has arrived to a distribution terminal and is waiting for final delivery
 *  - ON_HOLD: ON_HOLD indicates that the shipment is held up at the moment and some action is required.
 *  - RECEIVED_AT_PICKUP_POINT: RECEIVED_AT_PICKUP_POINT indicates that the package was put into a pickup locker.
 *  - DEPARTED_FROM_PICKUP_POINT: DEPARTED_FROM_PICKUP_POINT indicates that the package departed a pickup locker.
 *  - SHIPMENT_CANCELED: SHIPMENT_CANCELED indicates that a shipment has been canceled in SOM.
 *  - TRACKING_NUMBER_REGISTERED: TRACKING_NUMBER_REGISTERED indicates that the tracking number has been registered.
 *  - CUSTOM: CUSTOM indicates that event type was defined by external party.
 *  - LABEL_CREATED_BY_CARRIER: LABEL_CREATED_BY_CARRIER indicates that the label was created by carrier.
 *  - PICKUP_FAILED: PICKUP_FAILED indicates that the carrier failed to pickup the parcel.
 *  - RETURN_PICKUP_SCHEDULED: RETURN_PICKUP_SCHEDULED indicates that a return pickup has been booked.
 *  - CARRIER_PRODUCT_ID_ASSIGNED: CARRIER_PRODUCT_ID_ASSIGNED indicates that an internal carrier product ID was assigned to the tracking entity.
 *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
 *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
 *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
 *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
 *  - DAMAGED: DAMAGED indicates that package has been damaged.
 *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
 *  - PICKUP_DELAYED: PICKUP_DELAYED means the carrier will try to pick up the shipment again
 * or that the sender has rescheduled the pick-up date for the shipment.
 *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
 *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
 *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
 *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
 *  - DELIVERY_PROMISE_EXCEEDED: DELIVERY_PROMISE_EXCEEDED status is deprecated in favour of ESTIMATED_DELIVERY_TIME_EXCEEDED.
 *  - ESTIMATED_DELIVERY_TIME_EXCEEDED: ESTIMATED_DELIVERY_TIME_EXCEEDED indicates that the current ETA has been exceeded.
 *  - ESTIMATED_DELIVERY_TIME_UPDATED: ESTIMATED_DELIVERY_TIME_UPDATED indicates that ETA has been updated.
 *  - ESTIMATED_SUBMISSION_TIME_EXCEEDED: ESTIMATED_SUBMISSION_TIME_EXCEEDED indicates that the package pickup from point of origin is delayed.
 *  - ESTIMATED_SUBMISSION_TIME_UPDATED: ESTIMATED_SUBMISSION_TIME_UPDATED indicates that ETS has been updated.
 *  - ORDER_RECEIPT_AVAILABLE: ORDER_RECEIPT_AVAILABLE indicates that the order receipt is available for the consumer.
 *  - ORDER_CONFIRMED_BY_MERCHANT: ORDER_CONFIRMED_BY_MERCHANT indicates that the order has been confirmed by merchant.
 *
 * deprecated in favour of ORDER_CANCELLED
 *  - ORDER_CANCELLED_BY_MERCHANT: ORDER_CANCELLED_BY_MERCHANT indicates that the order has been cancelled by merchant.
 *
 * deprecated in favour of ORDER_CANCELLED
 *  - ORDER_CANCELLED_BY_CUSTOMER: ORDER_CANCELLED_BY_CUSTOMER indicates that the order has been cancelled by customer.
 *  - ORDER_ITEMS_CANCELLED: ORDER_ITEMS_CANCELLED indicates that the delivery does not contain all items from original order.
 *  - RETURN_RECEIPT_AVAILABLE: RETURN_RECEIPT_AVAILABLE indicates that the return receipt is available for the consumer.
 *  - PREPARED: PREPARED indicates that the order items have been prepared by the merchant.
 *  - SUBMITTED: SUBMITTED indicates that the order items have been submitteds to carrier.
 *  - AWAITING_SUPPLIER: AWAITING_SUPPLIER indicates that the merchant is awaiting item delivery from their supplier.
 *  - LINEHAUL_TO_CARRIER: LINEHAUL_TO_CARRIER indicates that ordered items are being transported to carrier.
 *  - ESTIMATED_PREPARATION_TIME_EXCEEDED: ESTIMATED_PREPARATION_TIME_EXCEEDED indicates that order items are taking longer than promised to prepare.
 *  - ESTIMATED_PREPARATION_TIME_UPDATED: ESTIMATED_PREPARATION_TIME_UPDATED indicates that the preparation promise for order items has been updated.
 *  - CENTRA_ORDER_CONFIRMED: CENTRA_ORDER_CONFIRMED indicates that the order has been confirmed in Centra platform.
 *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
 * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
 *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
 *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
 *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
 *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
 * It's indicates RETURN direction.
 *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
 *  - PRICE_ADJUSTMENT_RECEIPT_AVAILABLE: PRICE_ADJUSTMENT_RECEIPT_AVAILABLE indicates that the price adjustment receipt is available for the consumer.
 *  - NOTIFICATION_TRIGGERED: NOTIFICATION_TRIGGERED indicates that a tracking notification has been triggered in the Ingrid Tracking system.
 *  - NOTIFICATION_DELIVERED: NOTIFICATION_DELIVERED indicates that a delivery notification has been successfully delivered to the customer.
 *  - NOTIFICATION_FAILED: NOTIFICATION_FAILED indicates that a delivery notification has been failed to reach the customer.
 *  - ORDER_RETURNED_IN_STORE: ORDER_RETURNED_IN_STORE indicates that the order has been returned in merchant's store.
 *
 * deprecated in favour of ORDER_RETURNED
 *  - ORDER_RETURNED_TO_WAREHOUSE: ORDER_RETURNED_IN_STORE indicates that the order has been returned to the merchant's warehouse.
 *
 * deprecated in favour of ORDER_RETURNED
 *  - PAYMENT_DECLINED: PAYMENT_DECLINED indicates that we got PaymentDeclined exception.
 *  - NOT_COLLECTED_BY_CUSTOMER: NOT_COLLECTED_BY_CUSTOMER indicates that package/order was not collected in the pickup point.
 *  - REMAINING_SHIPMENTS_CANCELLED: REMAINING_SHIPMENTS_CANCELLED see RemainingShipmentsCancelled message comment.
 *  - CENTRA_DELIVERY_GROUP_CANCELLED: CENTRA_DELIVERY_GROUP_CANCELLED indicates that the delivery group has been cancelled in centra.
 *  - PICKUP_REMINDER_TRIGGERED: PICKUP_REMINDER_TRIGGERED  indicated that a reminder to pick up a parcel was triggered.
 *  - ORDER_RETURNED: ORDER_RETURNED indicates that the order has been returned.
 *  - ORDER_CANCELLED: ORDER_CANCELLED indicates that the order has been cancelled.
 *  - RETURN_REQUESTED: RETURN_REQUESTED indicates that the return process has been requested by the customer or merchant.
 * Strictly in the RETURN direction parcel.
 *  - INSTORE_PARCEL_SEND_ACCEPTED: INSTORE_PARCEL_SEND_ACCEPTED indicates that parcel was accepted in the store, but it does not belong to any order.
 *  - READY_FOR_PICKUP: READY_FOR_PICKUP indicates that a parcel is ready to be collected in the pickup location,
 * whether a carrier-managed location such as a locker or in a merchant-owned store.
 *  - PICKED_UP_BY_CUSTOMER: PICKED_UP_BY_CUSTOMER indicates that a parcel was picked up from the pickup location,
 * whether a carrier-managed location such as a locker or in a merchant-owned store.
 * @default "UNKNOWN"
 */
export type Status =
  | "UNKNOWN"
  | "ORDER_CREATED"
  | "ORDER_BOOKED"
  | "PICKUP_BOOKING_SCHEDULED"
  | "PICKUP_BOOKED"
  | "IN_TRANSIT"
  | "DELIVERY_IN_PROGRESS"
  | "ARRIVED_AT_PICKUP_POINT"
  | "DELIVERED"
  | "CANCELED"
  | "DELAYED"
  | "RETURNED"
  | "INFO"
  | "ERROR"
  | "SHIPMENT_CREATED"
  | "LOGISTIC_UNIT_CREATED"
  | "LOGISTIC_UNIT_RECEIVED_TRACKING_NUMBER"
  | "NOTIFICATION_SENT"
  | "BOOKING_RECEIVED_BY_CARRIER"
  | "FAILED"
  | "ARRIVED_AT_DISTRIBUTION_TERMINAL"
  | "ON_HOLD"
  | "RECEIVED_AT_PICKUP_POINT"
  | "DEPARTED_FROM_PICKUP_POINT"
  | "SHIPMENT_CANCELED"
  | "TRACKING_NUMBER_REGISTERED"
  | "CUSTOM"
  | "LABEL_CREATED_BY_CARRIER"
  | "PICKUP_FAILED"
  | "RETURN_PICKUP_SCHEDULED"
  | "CARRIER_PRODUCT_ID_ASSIGNED"
  | "FORWARDED_TO_THIRD_PARTY"
  | "IN_CUSTOMS"
  | "REDIRECTED"
  | "LOST"
  | "DAMAGED"
  | "RETURNED_TO_SENDER"
  | "PICKUP_DELAYED"
  | "PICKED_UP"
  | "UNDELIVERABLE"
  | "CONTACT_MERCHANT_SUPPORT"
  | "CONTACT_CARRIER_SUPPORT"
  | "DELIVERY_PROMISE_EXCEEDED"
  | "ESTIMATED_DELIVERY_TIME_EXCEEDED"
  | "ESTIMATED_DELIVERY_TIME_UPDATED"
  | "ESTIMATED_SUBMISSION_TIME_EXCEEDED"
  | "ESTIMATED_SUBMISSION_TIME_UPDATED"
  | "ORDER_RECEIPT_AVAILABLE"
  | "ORDER_CONFIRMED_BY_MERCHANT"
  | "ORDER_CANCELLED_BY_MERCHANT"
  | "ORDER_CANCELLED_BY_CUSTOMER"
  | "ORDER_ITEMS_CANCELLED"
  | "RETURN_RECEIPT_AVAILABLE"
  | "PREPARED"
  | "SUBMITTED"
  | "AWAITING_SUPPLIER"
  | "LINEHAUL_TO_CARRIER"
  | "ESTIMATED_PREPARATION_TIME_EXCEEDED"
  | "ESTIMATED_PREPARATION_TIME_UPDATED"
  | "CENTRA_ORDER_CONFIRMED"
  | "INSTORE_ARRIVED_AT_PICKUP_POINT"
  | "INSTORE_PARCEL_REFUSED"
  | "INSTORE_PARCEL_PICKED_UP"
  | "INSTORE_PARCEL_OVERDUE"
  | "INSTORE_PARCEL_RETURNED"
  | "INSTORE_PARCEL_RELOCATED"
  | "PRICE_ADJUSTMENT_RECEIPT_AVAILABLE"
  | "NOTIFICATION_TRIGGERED"
  | "NOTIFICATION_DELIVERED"
  | "NOTIFICATION_FAILED"
  | "ORDER_RETURNED_IN_STORE"
  | "ORDER_RETURNED_TO_WAREHOUSE"
  | "PAYMENT_DECLINED"
  | "NOT_COLLECTED_BY_CUSTOMER"
  | "REMAINING_SHIPMENTS_CANCELLED"
  | "CENTRA_DELIVERY_GROUP_CANCELLED"
  | "PICKUP_REMINDER_TRIGGERED"
  | "ORDER_RETURNED"
  | "ORDER_CANCELLED"
  | "RETURN_REQUESTED"
  | "INSTORE_PARCEL_SEND_ACCEPTED"
  | "READY_FOR_PICKUP"
  | "PICKED_UP_BY_CUSTOMER";

/** @default "STEP_UNKNOWN" */
export type Step =
  | "STEP_UNKNOWN"
  | "STEP_CONFIRMED_BY_MERCHANT"
  | "STEP_PREPARED_BY_MERCHANT"
  | "STEP_SUBMITTED_TO_CARRIER"
  | "STEP_ON_ROUTE"
  | "STEP_DELIVERED_TO_PICKUP_POINT"
  | "STEP_DELIVERED_TO_CONSUMER"
  | "STEP_TERMINATED"
  | "STEP_SENT_BACK"
  | "STEP_RETURN_REQUESTED"
  | "STEP_DELIVERED_TO_MERCHANT"
  | "STEP_AWAITING_SUPPLIER"
  | "STEP_LINEHAUL_TO_CARRIER";

export interface StringListWrapper {
  items?: string[];
}

export interface Style {
  accent_color_1?: string;
  accent_color_2?: string;
  color_button?: string;
  color_button_text?: string;
  color_checkbox?: string;
  color_checkbox_checkmark?: string;
  color_highlight?: string;
  color_link?: string;
  color_loader?: string;
  upsell_color?: string;
}

/**
 * Used when displaying delivery dates to the customer
 * @default "UNKNOWN_TIME_FORMATTING"
 */
export type TimeFormatting = "UNKNOWN_TIME_FORMATTING" | "MIN" | "MAX" | "INTERVAL";

/** @default "TRACKING_STATUS_UNKNOWN" */
export type TrackingConfigStatus =
  | "TRACKING_STATUS_UNKNOWN"
  | "TRACKING_STATUS_UNAVAILABLE"
  | "TRACKING_STATUS_AVAILABLE"
  | "TRACKING_STATUS_CONFIGURED";

export interface TrackingConfigurationStatus {
  status?: TrackingConfigStatus;
  tracking_variant_integration_statuses?: TrackingStatusByType[];
}

export interface TrackingStatusByType {
  ftp?: FTPPartialStatuses;
  polling?: PollingPartialStauses;
  pushing?: PushingPartialStatuses;
  status?: TrackingConfigStatus;
}

/**
 *  - TYPE_CARRIER_DEFAULT: Default addons returned in FetchShippingOptions under default_addons field.
 * Default addons are not presented to end customer in UI (all other delivery addons are presented).
 *  - TYPE_ID_CHECK: Basic identity check – courier verifies recipient’s ID at delivery.
 *  - TYPE_WITHOUT_ID_CHECK: Basic identity check – courier will not verify recipient’s ID at delivery.
 *  - TYPE_DIGITAL_CHECK: Digital identity verification using BankID or similar.
 *  - TYPE_ID_MATCH_RECIPIENT: ID must match the name of the recipient (e.g. delivery only to person on label).
 *  - TYPE_AGE_CHECK: Basic age verification – courier confirms recipient meets age requirement (typically 18+).
 *  - TYPE_EXTENDED_AGE_CHECK: Extended age verification – includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_16: Age check requiring the recipient to be at least 16 years old.
 *  - TYPE_EXTENDED_AGE_CHECK_16: Extended age check for 16+ –  includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_18: Age check requiring the recipient to be at least 18 years old.
 *  - TYPE_EXTENDED_AGE_CHECK_18: Extended age check for 18+ – includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_20: Age check requiring the recipient to be at least 20 years old.
 *  - TYPE_AGE_CHECK_21: Age check requiring the recipient to be at least 21 years old.
 *  - TYPE_EMAIL: Notify recipient via email when shipment status is updated.
 *  - TYPE_SMS: Notify recipient via SMS when shipment status is updated.
 *  - TYPE_LETTER: Notify recipient via physical letter (paper notice, e.g., undeliverable or missed delivery).
 *  - TYPE_CALL: Notify recipient via phone call (automated or manual).
 *  - TYPE_NOTIFICATION: General or fallback notification without specifying the communication channel.
 *  - TYPE_PRE_EMAIL: Notify recipient via email before the shipment is dispatched or delivered (pre-alert).
 *  - TYPE_PRE_SMS: Notify recipient via SMS before the shipment is dispatched or delivered (pre-alert).
 *  - TYPE_PRE_CALL: Notify recipient via phone call before the shipment is dispatched or delivered.
 *  - TYPE_PRE_NOTIFICATION: General pre-notification without specifying channel (can be email, SMS, or call).
 *  - TYPE_WITHOUT_PRE_NOTIFICATION: Shipment proceeds without any pre-notification.
 *  - TYPE_LEAVE_AT_DOOR: Leave the parcel at the recipient’s door or in a designated safe place without requiring interaction.
 *  - TYPE_CARRY_IN: Courier is required to carry the parcel inside the recipient's home or building.
 *  - TYPE_CARRY_OUT: Courier is required to carry the parcel outside the recipient's home or building.
 *  - TYPE_HOME_DELIVERY: Deliver the parcel directly to the recipient’s home address instead of a pickup location or access point.
 *  - TYPE_ENDORSEMENT_ABANDON: Abandon the shipment if it cannot be delivered (no return or retry attempt).
 *  - TYPE_PERSONAL_DELIVERY: Deliver the parcel directly into the hands of the recipient; no drop-off allowed.
 *  - TYPE_INSTALLATION: Perform installation of the delivered item at the recipient's location (e.g., appliances or furniture).
 *  - TYPE_REMOVAL: Remove old items (e.g., used furniture or appliances) from the recipient’s location as part of the delivery service.
 *  - TYPE_RECYCLE: Collect old or used items from the recipient for recycling during the delivery process.
 *  - TYPE_SWAP: Collect old or used items from the recipient during the delivery process and swap with the delivery.
 *  - TYPE_DISABLE_MODIFICATIONS: Prevents the recipient from modifying delivery options, such as changing delivery location, time, or leave-at-door settings.
 *  - TYPE_OPTIONAL_SERVICE_POINT: Allows the recipient to change the pickup location or service point before delivery.
 *  - TYPE_FLEX_CHANGE: Allows the recipient to flexibly change the delivery method, time, or location while the shipment is in transit.
 *  - TYPE_UNWRAPPING: Perform unwrapping on delivered item at recipient's location.
 *  - TYPE_PICKUP_POINT_DELIVERY: Deliver the parcel directly to the pickup location or access point.
 *  - TYPE_MAILBOX_DELIVERY: Deliver the parcel directly to the mailbox directly.
 *  - TYPE_DELIVERY_BEFORE_8: Deliver the parcel before 8:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_9: Deliver the parcel before 9:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_10: Deliver the parcel before 10:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_12: Deliver the parcel before 12:00 PM (noon) on the scheduled delivery day.
 *  - TYPE_EVENING_DELIVERY: Deliver the parcel during the evening hours, typically after 5:00 PM.
 *  - TYPE_EXPRESS_DELIVERY: Prioritize the shipment for the fastest possible delivery, typically within 1–2 days depending on the carrier.
 *  - TYPE_PRIORITY_DELIVERY: Prioritize internal processing of the shipment to improve transit performance (carrier-defined).
 *  - TYPE_SATURDAY_DELIVERY: Deliver the parcel on a Saturday, even if it is outside standard weekday schedules.
 *  - TYPE_SUNDAY_DELIVERY: Deliver the parcel on a Sunday, if available within the carrier’s service area.
 *  - TYPE_SAME_DAY_DELIVERY: Deliver the parcel on the same day it is shipped, usually within a few hours.
 *  - TYPE_TIME_AGREED_DELIVERY: Delivery at a specific time window agreed between the sender and the carrier.
 *  - TYPE_BY_TRUCK: Shipment must be delivered using a truck, typically due to size, weight, or palletized load.
 *  - TYPE_PALLET_TRANSFER: EUR-pallet must be exchanged at the time of delivery.
 *  - TYPE_FRANKED_POSTAGE: Pre-paid postage method where the sender uses a franking machine or online portal to apply postage instead of stamps.
 *  - TYPE_CONTAINER_RENT: Temporary rental of a container or shipping unit required for the transport. Typically used for pallet shipments.
 *  - TYPE_LOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be loaded onto the vehicle at the pickup location.
 *  - TYPE_UNLOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be unloaded from the vehicle at the delivery location.
 *  - TYPE_THERMO_COLD: Shipment requires cold temperature handling (e.g., 2–8°C).
 *  - TYPE_THERMO_FROZEN: Shipment must be kept frozen throughout transport. (e.g., below 0°C)
 *  - TYPE_THERMO_WARM: Shipment must be kept warm or above a certain minimum temperature (e.g., 8–25°C).
 *  - TYPE_LONG_GOODS: Item is long or oversized, requiring special handling or space.
 *  - TYPE_PHARMACEUTICALS: Shipment contains pharmaceuticals and may require regulated handling.
 *  - TYPE_DANGEROUS_GOODS: Shipment contains hazardous materials and must comply with safety regulations.
 *  - TYPE_DANGEROUS_GOODS_LQ: Shipment contains a limited quantity of dangerous goods, exempt from full ADR handling.
 *  - TYPE_NON_STACKABLE: Parcel cannot be stacked during transport.
 *  - TYPE_POSTABLE: Parcel can fit directly into a mailbox.
 *  - TYPE_HANGING_GARMENT: Shipment contains garments that must remain hanging during transit.
 *  - TYPE_FRAGILE: Parcel is fragile and must be handled with extra care.
 *  - TYPE_ALCOHOL: Shipment contains alcohol and may require age verification or special handling.
 *  - TYPE_TYRES: Shipment contains tires, often bulky and requiring dedicated space or securing.
 *  - TYPE_NICOTINE: Shipment contains nicotine products and may require legal handling procedures.
 *  - TYPE_HEAVY: Indicates that the shipment is heavy and may require special handling or lifting equipment.
 *  - TYPE_COD: The recipient pays for the goods or shipping upon delivery (cash, card, or local method).
 *  - TYPE_SHIPPING_DISCOUNT: Applies a negotiated discount or subsidy to the shipping cost (usually requires prior agreement).
 *  - TYPE_RECIPIENT_PAYS: The recipient is responsible for covering the shipping cost, typically via invoice or contract with the carrier.
 *  - TYPE_KIND_QUANTITY: Specifies the type and quantity of items in the shipment (e.g., 3 boxes, 2 bottles); often required for customs or tariff purposes.
 *  - TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION: Enables shipment to be billed after delivery via invoice, with official invoice documentation provided.
 *  - TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION: Enables post-delivery billing on credit without requiring formal invoice documentation.
 *  - TYPE_INSURANCE: Provides coverage for loss or damage of the shipment, based on declared value or carrier-specific terms.
 *  - TYPE_TERMINAL_PICKUP: The shipment will not be delivered to the recipient's address but must be picked up from a designated terminal or depot.
 *  - TYPE_PERSONAL_PICKUP: Shipment must be collected in person by the recipient, typically with ID verification, from a post office, store, or pickup point.
 *  - TYPE_RETENTION_EXTENDED: Extends the retention period for the shipment at the pickup location, typically from 7 to 14 days.
 *  - TYPE_RETURN_TO_SENDER: Instructs the carrier to return the shipment to the sender if it cannot be delivered to the recipient.
 *  - TYPE_RETURN_QR_CODE: Allows the recipient to return the shipment using a scannable QR code instead of / along with printed return label.
 *  - TYPE_PRINT_RETURN_LABEL: Enables printing of the return label at a pickup location or drop-off point, instead of requiring the sender to print it in advance.
 *  - TYPE_CLIMATE_COMPENSATION: Offsets the carbon emissions of the shipment by contributing to certified environmental initiatives.
 *  - TYPE_SHIPMENT_CONSOLIDATION: Indicates that multiple shipments are merged into one consolidated delivery, typically for logistical or operational efficiency.
 *  - TYPE_SHIPMENT_MULTI_PARCELS: Indicates that the shipment consists of multiple parcels under a single tracking number or delivery order.
 *  - TYPE_HIDE_CUSTOMER_PHONE: Hides the recipient's phone number from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_HIDE_CUSTOMER_EMAIL: Hides the recipient's email address from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS: Passes the customer's name as part of delivery instructions, often used to override carrier restrictions or labels.
 *  - TYPE_RESIDENTIAL_ADDRESS_INDICATOR: Marks the delivery address as a residential location, which may affect handling or surcharges.
 *  - TYPE_SPLIT_SHIPMENT: Splits the shipment into multiple parcels or deliveries, typically due to size, weight, or inventory constraints.
 *  - TYPE_HIDE_CUSTOMER_DETAILS: Hides the customer details from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_SIGNATURE: Requires the recipient (or someone at the address) to sign for the shipment upon delivery.
 *  - TYPE_ADULT_SIGNATURE: Requires a legally recognized adult to sign for the shipment, often used for age-restricted deliveries.
 *  - TYPE_INDIRECT_SIGNATURE: Allows someone other than the primary recipient (e.g., neighbor or receptionist) to sign for the shipment.
 *  - TYPE_WITHOUT_POD: The carrier will deliver the package without collecting a signature or proof of delivery.
 *  - TYPE_SIGNATURE_PHOTO_POD: Captures a photo as proof of delivery, often showing the parcel at the drop-off location.
 *  - TYPE_EXTENDED_SIGNATURE_POD: Includes multiple proof of deliveries, such as a high-resolution image, signature, timestamp, and geolocation.
 * @default "TYPE_UNKNOWN"
 */
export type Type =
  | "TYPE_UNKNOWN"
  | "TYPE_CUSTOM"
  | "TYPE_RETURN"
  | "TYPE_CARRIER"
  | "TYPE_CARRIER_DEFAULT"
  | "TYPE_ID_CHECK"
  | "TYPE_WITHOUT_ID_CHECK"
  | "TYPE_DIGITAL_CHECK"
  | "TYPE_ID_MATCH_RECIPIENT"
  | "TYPE_AGE_CHECK"
  | "TYPE_EXTENDED_AGE_CHECK"
  | "TYPE_AGE_CHECK_16"
  | "TYPE_EXTENDED_AGE_CHECK_16"
  | "TYPE_AGE_CHECK_18"
  | "TYPE_EXTENDED_AGE_CHECK_18"
  | "TYPE_AGE_CHECK_20"
  | "TYPE_AGE_CHECK_21"
  | "TYPE_EMAIL"
  | "TYPE_SMS"
  | "TYPE_LETTER"
  | "TYPE_CALL"
  | "TYPE_NOTIFICATION"
  | "TYPE_PRE_EMAIL"
  | "TYPE_PRE_SMS"
  | "TYPE_PRE_CALL"
  | "TYPE_PRE_NOTIFICATION"
  | "TYPE_WITHOUT_PRE_NOTIFICATION"
  | "TYPE_LEAVE_AT_DOOR"
  | "TYPE_CARRY_IN"
  | "TYPE_CARRY_OUT"
  | "TYPE_HOME_DELIVERY"
  | "TYPE_ENDORSEMENT_ABANDON"
  | "TYPE_PERSONAL_DELIVERY"
  | "TYPE_INSTALLATION"
  | "TYPE_REMOVAL"
  | "TYPE_RECYCLE"
  | "TYPE_SWAP"
  | "TYPE_DISABLE_MODIFICATIONS"
  | "TYPE_OPTIONAL_SERVICE_POINT"
  | "TYPE_FLEX_CHANGE"
  | "TYPE_UNWRAPPING"
  | "TYPE_PICKUP_POINT_DELIVERY"
  | "TYPE_MAILBOX_DELIVERY"
  | "TYPE_DELIVERY_BEFORE_8"
  | "TYPE_DELIVERY_BEFORE_9"
  | "TYPE_DELIVERY_BEFORE_10"
  | "TYPE_DELIVERY_BEFORE_12"
  | "TYPE_EVENING_DELIVERY"
  | "TYPE_EXPRESS_DELIVERY"
  | "TYPE_PRIORITY_DELIVERY"
  | "TYPE_SATURDAY_DELIVERY"
  | "TYPE_SUNDAY_DELIVERY"
  | "TYPE_SAME_DAY_DELIVERY"
  | "TYPE_TIME_AGREED_DELIVERY"
  | "TYPE_BY_TRUCK"
  | "TYPE_PALLET_TRANSFER"
  | "TYPE_FRANKED_POSTAGE"
  | "TYPE_CONTAINER_RENT"
  | "TYPE_LOADING_ASSISTANCE"
  | "TYPE_UNLOADING_ASSISTANCE"
  | "TYPE_THERMO_COLD"
  | "TYPE_THERMO_FROZEN"
  | "TYPE_THERMO_WARM"
  | "TYPE_LONG_GOODS"
  | "TYPE_PHARMACEUTICALS"
  | "TYPE_DANGEROUS_GOODS"
  | "TYPE_DANGEROUS_GOODS_LQ"
  | "TYPE_NON_STACKABLE"
  | "TYPE_POSTABLE"
  | "TYPE_HANGING_GARMENT"
  | "TYPE_FRAGILE"
  | "TYPE_ALCOHOL"
  | "TYPE_TYRES"
  | "TYPE_NICOTINE"
  | "TYPE_HEAVY"
  | "TYPE_COD"
  | "TYPE_SHIPPING_DISCOUNT"
  | "TYPE_RECIPIENT_PAYS"
  | "TYPE_KIND_QUANTITY"
  | "TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION"
  | "TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION"
  | "TYPE_INSURANCE"
  | "TYPE_TERMINAL_PICKUP"
  | "TYPE_PERSONAL_PICKUP"
  | "TYPE_RETENTION_EXTENDED"
  | "TYPE_RETURN_TO_SENDER"
  | "TYPE_RETURN_QR_CODE"
  | "TYPE_PRINT_RETURN_LABEL"
  | "TYPE_CLIMATE_COMPENSATION"
  | "TYPE_SHIPMENT_CONSOLIDATION"
  | "TYPE_SHIPMENT_MULTI_PARCELS"
  | "TYPE_HIDE_CUSTOMER_PHONE"
  | "TYPE_HIDE_CUSTOMER_EMAIL"
  | "TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS"
  | "TYPE_RESIDENTIAL_ADDRESS_INDICATOR"
  | "TYPE_SPLIT_SHIPMENT"
  | "TYPE_HIDE_CUSTOMER_DETAILS"
  | "TYPE_SIGNATURE"
  | "TYPE_ADULT_SIGNATURE"
  | "TYPE_INDIRECT_SIGNATURE"
  | "TYPE_WITHOUT_POD"
  | "TYPE_SIGNATURE_PHOTO_POD"
  | "TYPE_EXTENDED_SIGNATURE_POD";

export interface UpdateCarrierProductMappingRequest {
  always_show_tracking_links?: boolean;
  carrier_product_id?: string;
  carrier_product_ref?: string;
  custom?: boolean;
  id?: string;
  tracking_links?: Record<string, string>;
}

export interface UpdateCarrierProductMappingResponse {
  /** @format int64 */
  version?: string;
}

export interface UpdateCategoryCountrySettingsRequest {
  country?: string;
  country_settings?: CategoryCountrySettings[];
}

export interface UpdateCategoryCountrySettingsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateCategoryDeliveryTimeRequest {
  /** Identifier of the category being edited. [required] */
  category_id?: string;
  /** Time formatting style. */
  format?: string;
  /**
   * Maximum of the default delivery time range.
   * @format int32
   */
  max?: number;
  /**
   * Minimum of the default delivery time range.
   * @format int32
   */
  min?: number;
  /** Delivery time unit (eg. "day", "business_day"). */
  unit?: string;
}

export interface UpdateCategoryDeliveryTimeResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateCategoryDetailsRequest {
  additional_options?: ShippingCategoryAdditionalOptions;
  /** Identifier of the category being edited. [required] */
  category_id?: string;
  custom_info_text?: string;
  custom_text?: string;
  custom_unavailable_text?: string;
  custom_warning_text?: string;
  delivery_time?: DeliveryTimeWrapper;
  delivery_time_properties?: DeliveryTimePropertiesWrapper;
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  external_id?: string;
  filter_rules?: FilterRule[];
  /** @format int32 */
  max_choices_count?: number;
  methods?: StringListWrapper;
  /** [deprecated] methods field should be used instead. */
  methods_old?: string[];
  name?: string;
  preselected?: boolean;
  region_ids?: string[];
  requirements?: ShippingCategoryRequirementsWrapper;
  show_on_faq_widget?: boolean;
  /** @format int32 */
  sort_order?: number;
  state?: State;
  time_formatting?: TimeFormatting;
}

export interface UpdateCategoryDetailsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateCategoryFilterRulesRequest {
  category_id?: string;
  filter_rules?: FilterRule[];
}

export interface UpdateCategoryLabelRequest {
  category_id?: string;
  color?: string;
  dark_mode_color?: string;
  icon?: string;
  label_id?: string;
  name?: string;
  state?: State;
  type?: LabelType;
}

export interface UpdateCategoryLabelResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateCategoryTranslationsRequest {
  /** Identifier of the category being edited. [required] */
  category_id?: string;
  /** Category custom info text. */
  custom_info_text?: string;
  /** Category custom text. */
  custom_text?: string;
  /** Category custom warning text. */
  custom_warning_text?: string;
  /** Locale in which translations are to be edited. [required] */
  locale?: string;
  /** Category name. */
  name?: string;
}

export interface UpdateCategoryTranslationsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateDefaultCategoryPriceRequest {
  /** Identifier of the category being edited. [required] */
  category_id?: string;
  /** Currency that is to be edited. [required] */
  currency?: string;
  /** Shipping method of which prices is to be edited. [required] */
  shipping_method?: string;
  /**
   * Price value that is to be edited. [required]
   * @format int32
   */
  value?: number;
}

export interface UpdateDefaultCategoryPriceResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateDeliveryAddonRequest {
  addon_id?: string;
  category_id?: string;
  defaults?: DeliveryAddonDefaults;
  external_id?: string;
  name?: string;
  price?: DeliveryAddonPrice;
  state?: State;
  /**
   *  - TYPE_CARRIER_DEFAULT: Default addons returned in FetchShippingOptions under default_addons field.
   * Default addons are not presented to end customer in UI (all other delivery addons are presented).
   *  - TYPE_ID_CHECK: Basic identity check – courier verifies recipient’s ID at delivery.
   *  - TYPE_WITHOUT_ID_CHECK: Basic identity check – courier will not verify recipient’s ID at delivery.
   *  - TYPE_DIGITAL_CHECK: Digital identity verification using BankID or similar.
   *  - TYPE_ID_MATCH_RECIPIENT: ID must match the name of the recipient (e.g. delivery only to person on label).
   *  - TYPE_AGE_CHECK: Basic age verification – courier confirms recipient meets age requirement (typically 18+).
   *  - TYPE_EXTENDED_AGE_CHECK: Extended age verification – includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_16: Age check requiring the recipient to be at least 16 years old.
   *  - TYPE_EXTENDED_AGE_CHECK_16: Extended age check for 16+ –  includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_18: Age check requiring the recipient to be at least 18 years old.
   *  - TYPE_EXTENDED_AGE_CHECK_18: Extended age check for 18+ – includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_20: Age check requiring the recipient to be at least 20 years old.
   *  - TYPE_AGE_CHECK_21: Age check requiring the recipient to be at least 21 years old.
   *  - TYPE_EMAIL: Notify recipient via email when shipment status is updated.
   *  - TYPE_SMS: Notify recipient via SMS when shipment status is updated.
   *  - TYPE_LETTER: Notify recipient via physical letter (paper notice, e.g., undeliverable or missed delivery).
   *  - TYPE_CALL: Notify recipient via phone call (automated or manual).
   *  - TYPE_NOTIFICATION: General or fallback notification without specifying the communication channel.
   *  - TYPE_PRE_EMAIL: Notify recipient via email before the shipment is dispatched or delivered (pre-alert).
   *  - TYPE_PRE_SMS: Notify recipient via SMS before the shipment is dispatched or delivered (pre-alert).
   *  - TYPE_PRE_CALL: Notify recipient via phone call before the shipment is dispatched or delivered.
   *  - TYPE_PRE_NOTIFICATION: General pre-notification without specifying channel (can be email, SMS, or call).
   *  - TYPE_WITHOUT_PRE_NOTIFICATION: Shipment proceeds without any pre-notification.
   *  - TYPE_LEAVE_AT_DOOR: Leave the parcel at the recipient’s door or in a designated safe place without requiring interaction.
   *  - TYPE_CARRY_IN: Courier is required to carry the parcel inside the recipient's home or building.
   *  - TYPE_CARRY_OUT: Courier is required to carry the parcel outside the recipient's home or building.
   *  - TYPE_HOME_DELIVERY: Deliver the parcel directly to the recipient’s home address instead of a pickup location or access point.
   *  - TYPE_ENDORSEMENT_ABANDON: Abandon the shipment if it cannot be delivered (no return or retry attempt).
   *  - TYPE_PERSONAL_DELIVERY: Deliver the parcel directly into the hands of the recipient; no drop-off allowed.
   *  - TYPE_INSTALLATION: Perform installation of the delivered item at the recipient's location (e.g., appliances or furniture).
   *  - TYPE_REMOVAL: Remove old items (e.g., used furniture or appliances) from the recipient’s location as part of the delivery service.
   *  - TYPE_RECYCLE: Collect old or used items from the recipient for recycling during the delivery process.
   *  - TYPE_SWAP: Collect old or used items from the recipient during the delivery process and swap with the delivery.
   *  - TYPE_DISABLE_MODIFICATIONS: Prevents the recipient from modifying delivery options, such as changing delivery location, time, or leave-at-door settings.
   *  - TYPE_OPTIONAL_SERVICE_POINT: Allows the recipient to change the pickup location or service point before delivery.
   *  - TYPE_FLEX_CHANGE: Allows the recipient to flexibly change the delivery method, time, or location while the shipment is in transit.
   *  - TYPE_UNWRAPPING: Perform unwrapping on delivered item at recipient's location.
   *  - TYPE_PICKUP_POINT_DELIVERY: Deliver the parcel directly to the pickup location or access point.
   *  - TYPE_MAILBOX_DELIVERY: Deliver the parcel directly to the mailbox directly.
   *  - TYPE_DELIVERY_BEFORE_8: Deliver the parcel before 8:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_9: Deliver the parcel before 9:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_10: Deliver the parcel before 10:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_12: Deliver the parcel before 12:00 PM (noon) on the scheduled delivery day.
   *  - TYPE_EVENING_DELIVERY: Deliver the parcel during the evening hours, typically after 5:00 PM.
   *  - TYPE_EXPRESS_DELIVERY: Prioritize the shipment for the fastest possible delivery, typically within 1–2 days depending on the carrier.
   *  - TYPE_PRIORITY_DELIVERY: Prioritize internal processing of the shipment to improve transit performance (carrier-defined).
   *  - TYPE_SATURDAY_DELIVERY: Deliver the parcel on a Saturday, even if it is outside standard weekday schedules.
   *  - TYPE_SUNDAY_DELIVERY: Deliver the parcel on a Sunday, if available within the carrier’s service area.
   *  - TYPE_SAME_DAY_DELIVERY: Deliver the parcel on the same day it is shipped, usually within a few hours.
   *  - TYPE_TIME_AGREED_DELIVERY: Delivery at a specific time window agreed between the sender and the carrier.
   *  - TYPE_BY_TRUCK: Shipment must be delivered using a truck, typically due to size, weight, or palletized load.
   *  - TYPE_PALLET_TRANSFER: EUR-pallet must be exchanged at the time of delivery.
   *  - TYPE_FRANKED_POSTAGE: Pre-paid postage method where the sender uses a franking machine or online portal to apply postage instead of stamps.
   *  - TYPE_CONTAINER_RENT: Temporary rental of a container or shipping unit required for the transport. Typically used for pallet shipments.
   *  - TYPE_LOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be loaded onto the vehicle at the pickup location.
   *  - TYPE_UNLOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be unloaded from the vehicle at the delivery location.
   *  - TYPE_THERMO_COLD: Shipment requires cold temperature handling (e.g., 2–8°C).
   *  - TYPE_THERMO_FROZEN: Shipment must be kept frozen throughout transport. (e.g., below 0°C)
   *  - TYPE_THERMO_WARM: Shipment must be kept warm or above a certain minimum temperature (e.g., 8–25°C).
   *  - TYPE_LONG_GOODS: Item is long or oversized, requiring special handling or space.
   *  - TYPE_PHARMACEUTICALS: Shipment contains pharmaceuticals and may require regulated handling.
   *  - TYPE_DANGEROUS_GOODS: Shipment contains hazardous materials and must comply with safety regulations.
   *  - TYPE_DANGEROUS_GOODS_LQ: Shipment contains a limited quantity of dangerous goods, exempt from full ADR handling.
   *  - TYPE_NON_STACKABLE: Parcel cannot be stacked during transport.
   *  - TYPE_POSTABLE: Parcel can fit directly into a mailbox.
   *  - TYPE_HANGING_GARMENT: Shipment contains garments that must remain hanging during transit.
   *  - TYPE_FRAGILE: Parcel is fragile and must be handled with extra care.
   *  - TYPE_ALCOHOL: Shipment contains alcohol and may require age verification or special handling.
   *  - TYPE_TYRES: Shipment contains tires, often bulky and requiring dedicated space or securing.
   *  - TYPE_NICOTINE: Shipment contains nicotine products and may require legal handling procedures.
   *  - TYPE_HEAVY: Indicates that the shipment is heavy and may require special handling or lifting equipment.
   *  - TYPE_COD: The recipient pays for the goods or shipping upon delivery (cash, card, or local method).
   *  - TYPE_SHIPPING_DISCOUNT: Applies a negotiated discount or subsidy to the shipping cost (usually requires prior agreement).
   *  - TYPE_RECIPIENT_PAYS: The recipient is responsible for covering the shipping cost, typically via invoice or contract with the carrier.
   *  - TYPE_KIND_QUANTITY: Specifies the type and quantity of items in the shipment (e.g., 3 boxes, 2 bottles); often required for customs or tariff purposes.
   *  - TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION: Enables shipment to be billed after delivery via invoice, with official invoice documentation provided.
   *  - TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION: Enables post-delivery billing on credit without requiring formal invoice documentation.
   *  - TYPE_INSURANCE: Provides coverage for loss or damage of the shipment, based on declared value or carrier-specific terms.
   *  - TYPE_TERMINAL_PICKUP: The shipment will not be delivered to the recipient's address but must be picked up from a designated terminal or depot.
   *  - TYPE_PERSONAL_PICKUP: Shipment must be collected in person by the recipient, typically with ID verification, from a post office, store, or pickup point.
   *  - TYPE_RETENTION_EXTENDED: Extends the retention period for the shipment at the pickup location, typically from 7 to 14 days.
   *  - TYPE_RETURN_TO_SENDER: Instructs the carrier to return the shipment to the sender if it cannot be delivered to the recipient.
   *  - TYPE_RETURN_QR_CODE: Allows the recipient to return the shipment using a scannable QR code instead of / along with printed return label.
   *  - TYPE_PRINT_RETURN_LABEL: Enables printing of the return label at a pickup location or drop-off point, instead of requiring the sender to print it in advance.
   *  - TYPE_CLIMATE_COMPENSATION: Offsets the carbon emissions of the shipment by contributing to certified environmental initiatives.
   *  - TYPE_SHIPMENT_CONSOLIDATION: Indicates that multiple shipments are merged into one consolidated delivery, typically for logistical or operational efficiency.
   *  - TYPE_SHIPMENT_MULTI_PARCELS: Indicates that the shipment consists of multiple parcels under a single tracking number or delivery order.
   *  - TYPE_HIDE_CUSTOMER_PHONE: Hides the recipient's phone number from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_HIDE_CUSTOMER_EMAIL: Hides the recipient's email address from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS: Passes the customer's name as part of delivery instructions, often used to override carrier restrictions or labels.
   *  - TYPE_RESIDENTIAL_ADDRESS_INDICATOR: Marks the delivery address as a residential location, which may affect handling or surcharges.
   *  - TYPE_SPLIT_SHIPMENT: Splits the shipment into multiple parcels or deliveries, typically due to size, weight, or inventory constraints.
   *  - TYPE_HIDE_CUSTOMER_DETAILS: Hides the customer details from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_SIGNATURE: Requires the recipient (or someone at the address) to sign for the shipment upon delivery.
   *  - TYPE_ADULT_SIGNATURE: Requires a legally recognized adult to sign for the shipment, often used for age-restricted deliveries.
   *  - TYPE_INDIRECT_SIGNATURE: Allows someone other than the primary recipient (e.g., neighbor or receptionist) to sign for the shipment.
   *  - TYPE_WITHOUT_POD: The carrier will deliver the package without collecting a signature or proof of delivery.
   *  - TYPE_SIGNATURE_PHOTO_POD: Captures a photo as proof of delivery, often showing the parcel at the drop-off location.
   *  - TYPE_EXTENDED_SIGNATURE_POD: Includes multiple proof of deliveries, such as a high-resolution image, signature, timestamp, and geolocation.
   */
  type?: Type;
}

export interface UpdateDeliveryAddonResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateDeliveryTimePropertiesTranslationsRequest {
  /** Identifer of the category being edited. [required] */
  category_id?: string;
  /** DeliveryTimeProperties custom text. */
  custom_text?: string;
  /** Locale in which translations are to be edited. [required] */
  locale?: string;
}

export interface UpdateDeliveryTimePropertiesTranslationsResponse {
  /** @format int64 */
  version?: string;
}

export interface UpdateDeliveryUpsellWidgetConfigurationRequest {
  widget_configuration?: DeliveryUpsellWidgetConfiguration;
}

export interface UpdateDeliveryUpsellWidgetConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateDeliveryUpsellWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
  features?: DeliveryUpsellWidgetFeaturesWrapper;
}

export interface UpdateDeliveryUpsellWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateFaqWidgetDefaultConfigurationRequest {
  features?: FaqWidgetFeatures;
}

export interface UpdateFaqWidgetDefaultConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateProductPageWidgetDefaultConfigurationRequest {
  features?: ProductPageWidgetFeatures;
}

export interface UpdateProductPageWidgetDefaultConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateReceiptWidgetDefaultConfigurationRequest {
  features?: ReceiptWidgetFeatures;
}

export interface UpdateReceiptWidgetDefaultConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateRegionDetailsRequest {
  country_config?: CountryRegionConfig;
  currency?: string;
  features?: RegionFeatures;
  group_id?: string;
  name?: string;
  postalcode_config?: PostalcodeRegionConfig;
  /** Identifier of the region being edited. [required] */
  region_id?: string;
  region_type?: string;
  state?: State;
  warehouse_id?: string;
}

export interface UpdateRegionDetailsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateRegionProductFilerRulesRequest {
  delivery_types?: DeliveryType[];
  filter_rules?: FilterRule[];
  method?: string;
  post_filter_rules?: UpdateRegionProductFilerRulesRequestPostFilterRule[];
  region_id?: string;
}

export interface UpdateRegionProductFilerRulesRequestPostFilterRule {
  condition?: string;
}

export interface UpdateRegionProductPriceRulesRequest {
  composite_price_rule?: CompositePriceRuleWrapper;
  delivery_types?: DeliveryType[];
  group_price_rules?: CheckoutGroupPriceRule[];
  method?: string;
  price_rules?: PriceRule[];
  region_id?: string;
}

export interface UpdateRegionProductRequest {
  composite_price_rule?: CompositePriceRuleWrapper;
  delivery_time?: DeliveryTimeWrapper;
  /** Identifier of the delivery type of the product being edited. [required] */
  delivery_types?: DeliveryType[];
  external_method_id?: string;
  filter_rules?: FilterRule[];
  generate_default_shipping_options_on_error?: boolean;
  group_price_rules?: CheckoutGroupPriceRule[];
  /** Identifier of the shipping product being edited. [required] */
  method?: string;
  operating_schedule?: OperatingScheduleCarrierItemWrapper;
  price_rules?: PriceRule[];
  /** Identifier of the request in which a product is being edited. [required] */
  region_id?: string;
  shipping_date_adjustment?: ShippingDateAdjustmentWrapper;
  supported_shipping_attributes?: string[];
}

export interface UpdateRegionProductResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateServiceConfigurationRequest {
  /** Contents of the service configuration. [required] */
  configuration?: ServiceConfiguration;
  /** Identifier of the service configuration. [required] */
  key?: string;
}

export interface UpdateServiceConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateSiteResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateSortingRulesRequest {
  site_id?: string;
  sorting_rules?: SortingRule[];
}

export type UpdateSortingRulesResponse = object;

export interface UpdateWarehouseCutoffTimesRequest {
  carrier_cutoff?: boolean;
  cutoff_times?: Record<string, OperatingScheduleCutoffTimes>;
  /** Identifier of the method being edited. [required] */
  method?: string;
  operating_schedule_exceptions?: OperatingScheduleException[];
  /** Identifier of the warehouse being edited. [required] */
  warehouse_id?: string;
}

export interface UpdateWarehouseCutoffTimesResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateWarehouseDetailsRequest {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  contact_data?: ContactData;
  external_id?: string;
  state?: State;
  timezone?: string;
  /** Identifier of the warehouse being edited. [required] */
  warehouse_id?: string;
}

export interface UpdateWarehouseDetailsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateWidgetConfigurationRequest {
  widget_configuration?: WidgetConfiguration;
}

export interface UpdateWidgetConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpdateWidgetCountryConfigurationRequest {
  carrier_logos?: MethodListWrapper;
  /** The name of the country. [required] */
  country?: string;
  features?: FeaturesWrapper;
  upfront_carriers?: MethodListWrapper;
}

export interface UpdateWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertCarrierProductSettingsRequest {
  always_show_tracking_links?: boolean;
  carrier_product_id?: string;
  /** Setting 'custom' to true implies that tracking URLs must be provided. */
  custom?: boolean;
  /** Locale to tracking URL map. */
  tracking_links?: Record<string, string>;
}

export interface UpsertCarrierProductSettingsResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertCategoryLabelTranslationRequest {
  category_id?: string;
  description?: string;
  label_id?: string;
  locale?: string;
  name?: string;
}

export interface UpsertCategoryLabelTranslationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertCustomEventTypeRequest {
  id?: string;
  name?: string;
  state?: State;
}

export interface UpsertCustomEventTypeResponse {
  id?: string;
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertCustomEventTypeTranslationRequest {
  description?: string;
  id?: string;
  locale?: string;
  name?: string;
}

export interface UpsertCustomEventTypeTranslationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertDeliveryAddonTranslationRequest {
  addon_id?: string;
  category_id?: string;
  description?: string;
  locale?: string;
  name?: string;
}

export interface UpsertDeliveryAddonTranslationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertFaqWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
  features?: FaqWidgetFeatures;
}

export interface UpsertFaqWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertProductPageWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
  features?: ProductPageWidgetFeatures;
}

export interface UpsertProductPageWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface UpsertReceiptWidgetCountryConfigurationRequest {
  /** The name of the country. [required] */
  country?: string;
  features?: ReceiptWidgetFeatures;
}

export interface UpsertReceiptWidgetCountryConfigurationResponse {
  /**
   * Version of the updated site.
   * @format int64
   */
  version?: string;
}

export interface ValidationSettingsPostalCodeValidationSettings {
  during_fetch_shipping_option?: boolean;
  during_validate_shipment?: boolean;
}

export interface WidgetConfiguration {
  by_country?: Record<string, WidgetCountryConfiguration>;
  features?: Features;
  release_label?: string;
  shipping_option_configuration?: Record<string, ShippingOptionConfiguration>;
  style?: Style;
  /** Deprecated, use by_country.upfront_carriers instead. [deprecated] */
  upfront_carriers?: Record<string, MethodList>;
}

export interface WidgetCountryConfiguration {
  carrier_logos?: MethodList;
  features?: Features;
  upfront_carriers?: MethodList;
}

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/selfcare" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title SelfCare API
 * @version 1.0
 * @baseUrl /v1/selfcare
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  carrierProductMappingCreate = {
    /**
     * No description
     *
     * @name SelfCareCreateCarrierProductMapping
     * @request POST:/carrier_product_mapping.create
     * @secure
     */
    selfCareCreateCarrierProductMapping: (body: CreateCarrierProductMappingRequest, params: RequestParams = {}) =>
      this.request<CreateCarrierProductMappingResponse, Error>({
        path: `/carrier_product_mapping.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  carrierProductMappingDelete = {
    /**
     * No description
     *
     * @name SelfCareDeleteCarrierProductMapping
     * @request POST:/carrier_product_mapping.delete
     * @secure
     */
    selfCareDeleteCarrierProductMapping: (body: DeleteCarrierProductMappingRequest, params: RequestParams = {}) =>
      this.request<DeleteCarrierProductMappingResponse, Error>({
        path: `/carrier_product_mapping.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  carrierProductMappingList = {
    /**
     * No description
     *
     * @name SelfCareListCarrierProductMapping
     * @request GET:/carrier_product_mapping.list
     * @secure
     */
    selfCareListCarrierProductMapping: (params: RequestParams = {}) =>
      this.request<ListCarrierProductMappingResponse, Error>({
        path: `/carrier_product_mapping.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  carrierProductMappingUpdate = {
    /**
     * No description
     *
     * @name SelfCareUpdateCarrierProductMapping
     * @request POST:/carrier_product_mapping.update
     * @secure
     */
    selfCareUpdateCarrierProductMapping: (body: UpdateCarrierProductMappingRequest, params: RequestParams = {}) =>
      this.request<UpdateCarrierProductMappingResponse, Error>({
        path: `/carrier_product_mapping.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  carrierProductSettingsList = {
    /**
     * No description
     *
     * @name SelfCareListCarrierProductSettings
     * @request GET:/carrier_product_settings.list
     * @secure
     */
    selfCareListCarrierProductSettings: (
      query?: {
        site_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListCarrierProductSettingsResponse, Error>({
        path: `/carrier_product_settings.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  carrierProductSettingsUpsert = {
    /**
     * No description
     *
     * @name SelfCareUpsertCarrierProductSettings
     * @request POST:/carrier_product_settings.upsert
     * @secure
     */
    selfCareUpsertCarrierProductSettings: (body: UpsertCarrierProductSettingsRequest, params: RequestParams = {}) =>
      this.request<UpsertCarrierProductSettingsResponse, Error>({
        path: `/carrier_product_settings.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  carrierProductsList = {
    /**
     * No description
     *
     * @name SelfCareListCarrierProducts
     * @request GET:/carrier_products.list
     * @secure
     */
    selfCareListCarrierProducts: (params: RequestParams = {}) =>
      this.request<ListCarrierProductsResponse, Error>({
        path: `/carrier_products.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  categoriesList = {
    /**
     * No description
     *
     * @name SelfCareListCategories
     * @request GET:/categories.list
     * @secure
     */
    selfCareListCategories: (
      query?: {
        /**
         *  - UNKNOWN: Delivery type is not known for some reason
         *  - DELIVERY: Home delivery
         *  - PICKUP: Delivery to a service point or a locker
         *  - MAILBOX: Delivery to customer's mailbox
         *  - INSTORE: Delivery to one of the merchants stores
         *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
         */
        "filtering.delivery_types"?: ("UNKNOWN" | "DELIVERY" | "PICKUP" | "MAILBOX" | "INSTORE" | "INWAREHOUSE")[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ListCategoriesResponse, Error>({
        path: `/categories.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  category = {
    /**
     * No description
     *
     * @name SelfCareUpdateCategoryCountrySettings
     * @request POST:/category/country_settings
     * @secure
     */
    selfCareUpdateCategoryCountrySettings: (body: UpdateCategoryCountrySettingsRequest, params: RequestParams = {}) =>
      this.request<UpdateCategoryCountrySettingsResponse, Error>({
        path: `/category/country_settings`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateCategory
     * @request POST:/category/create
     * @secure
     */
    selfCareCreateCategory: (body: CreateCategoryRequest, params: RequestParams = {}) =>
      this.request<CreateCategoryResponse, Error>({
        path: `/category/create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteCategory
     * @request POST:/category/delete
     * @secure
     */
    selfCareDeleteCategory: (body: DeleteCategoryRequest, params: RequestParams = {}) =>
      this.request<DeleteCategoryResponse, Error>({
        path: `/category/delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareAdjustDeliveryAddonOrder
     * @request POST:/category/delivery_addons.adjust_order
     * @secure
     */
    selfCareAdjustDeliveryAddonOrder: (body: AdjustDeliveryAddonsOrderRequest, params: RequestParams = {}) =>
      this.request<AdjustDeliveryAddonsOrderResponse, Error>({
        path: `/category/delivery_addons.adjust_order`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateDeliveryAddon
     * @summary Delivery addons
     * @request POST:/category/delivery_addons.create
     * @secure
     */
    selfCareCreateDeliveryAddon: (body: CreateDeliveryAddonRequest, params: RequestParams = {}) =>
      this.request<CreateDeliveryAddonResponse, Error>({
        path: `/category/delivery_addons.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteDeliveryAddon
     * @request POST:/category/delivery_addons.delete
     * @secure
     */
    selfCareDeleteDeliveryAddon: (body: DeleteDeliveryAddonRequest, params: RequestParams = {}) =>
      this.request<DeleteDeliveryAddonResponse, Error>({
        path: `/category/delivery_addons.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateDeliveryAddon
     * @request POST:/category/delivery_addons.update
     * @secure
     */
    selfCareUpdateDeliveryAddon: (body: UpdateDeliveryAddonRequest, params: RequestParams = {}) =>
      this.request<UpdateDeliveryAddonResponse, Error>({
        path: `/category/delivery_addons.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteDeliveryAddonTranslation
     * @request POST:/category/delivery_addons_translation.delete
     * @secure
     */
    selfCareDeleteDeliveryAddonTranslation: (body: DeleteDeliveryAddonTranslationRequest, params: RequestParams = {}) =>
      this.request<DeleteDeliveryAddonTranslationResponse, Error>({
        path: `/category/delivery_addons_translation.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpsertDeliveryAddonTranslation
     * @request POST:/category/delivery_addons_translation.upsert
     * @secure
     */
    selfCareUpsertDeliveryAddonTranslation: (body: UpsertDeliveryAddonTranslationRequest, params: RequestParams = {}) =>
      this.request<UpsertDeliveryAddonTranslationResponse, Error>({
        path: `/category/delivery_addons_translation.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateCategoryDeliveryTime
     * @request POST:/category/delivery_time.update
     * @secure
     */
    selfCareUpdateCategoryDeliveryTime: (body: UpdateCategoryDeliveryTimeRequest, params: RequestParams = {}) =>
      this.request<UpdateCategoryDeliveryTimeResponse, Error>({
        path: `/category/delivery_time.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteDeliveryPropertiesTranslations
     * @request POST:/category/delivery_time_translations.delete
     * @secure
     */
    selfCareDeleteDeliveryPropertiesTranslations: (
      body: DeleteDeliveryTimePropertiesTranslationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDeliveryTimePropertiesTranslationsResponse, Error>({
        path: `/category/delivery_time_translations.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateDeliveryPropertiesTranslations
     * @request POST:/category/delivery_time_translations.update
     * @secure
     */
    selfCareUpdateDeliveryPropertiesTranslations: (
      body: UpdateDeliveryTimePropertiesTranslationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDeliveryTimePropertiesTranslationsResponse, Error>({
        path: `/category/delivery_time_translations.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateCategoryDetails
     * @request POST:/category/details.update
     * @secure
     */
    selfCareUpdateCategoryDetails: (body: UpdateCategoryDetailsRequest, params: RequestParams = {}) =>
      this.request<UpdateCategoryDetailsResponse, Error>({
        path: `/category/details.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateCategoryFilterRules
     * @request POST:/category/filter_rules.update
     * @secure
     */
    selfCareUpdateCategoryFilterRules: (body: UpdateCategoryFilterRulesRequest, params: RequestParams = {}) =>
      this.request<UpdateSiteResponse, Error>({
        path: `/category/filter_rules.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareAdjustCategoryLabelsOrder
     * @request POST:/category/labels.adjust_order
     * @secure
     */
    selfCareAdjustCategoryLabelsOrder: (body: AdjustCategoryLabelsOrderRequest, params: RequestParams = {}) =>
      this.request<AdjustCategoryLabelsOrderResponse, Error>({
        path: `/category/labels.adjust_order`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateCategoryLabel
     * @request POST:/category/labels.create
     * @secure
     */
    selfCareCreateCategoryLabel: (body: CreateCategoryLabelRequest, params: RequestParams = {}) =>
      this.request<CreateCategoryLabelResponse, Error>({
        path: `/category/labels.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteCategoryLabel
     * @request POST:/category/labels.delete
     * @secure
     */
    selfCareDeleteCategoryLabel: (body: DeleteCategoryLabelRequest, params: RequestParams = {}) =>
      this.request<DeleteCategoryLabelResponse, Error>({
        path: `/category/labels.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateCategoryLabel
     * @request POST:/category/labels.update
     * @secure
     */
    selfCareUpdateCategoryLabel: (body: UpdateCategoryLabelRequest, params: RequestParams = {}) =>
      this.request<UpdateCategoryLabelResponse, Error>({
        path: `/category/labels.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteCategoryLabelTranslation
     * @request POST:/category/labels_translation.delete
     * @secure
     */
    selfCareDeleteCategoryLabelTranslation: (body: DeleteCategoryLabelTranslationRequest, params: RequestParams = {}) =>
      this.request<DeleteCategoryLabelTranslationResponse, Error>({
        path: `/category/labels_translation.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpsertCategoryLabelTranslation
     * @request POST:/category/labels_translation.upsert
     * @secure
     */
    selfCareUpsertCategoryLabelTranslation: (body: UpsertCategoryLabelTranslationRequest, params: RequestParams = {}) =>
      this.request<UpsertCategoryLabelTranslationResponse, Error>({
        path: `/category/labels_translation.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateDefaultCategoryPrice
     * @request POST:/category/price.update
     * @secure
     */
    selfCareUpdateDefaultCategoryPrice: (body: UpdateDefaultCategoryPriceRequest, params: RequestParams = {}) =>
      this.request<UpdateDefaultCategoryPriceResponse, Error>({
        path: `/category/price.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareAddCategoryTag
     * @request POST:/category/tags.add
     * @secure
     */
    selfCareAddCategoryTag: (body: AddCategoryTagRequest, params: RequestParams = {}) =>
      this.request<ListCarrierProductsRequest, Error>({
        path: `/category/tags.add`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareRemoveCategoryTag
     * @request POST:/category/tags.remove
     * @secure
     */
    selfCareRemoveCategoryTag: (body: RemoveCategoryTagRequest, params: RequestParams = {}) =>
      this.request<ListCarrierProductsRequest, Error>({
        path: `/category/tags.remove`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteCategoryTranslations
     * @request POST:/category/translations.delete
     * @secure
     */
    selfCareDeleteCategoryTranslations: (body: DeleteCategoryTranslationsRequest, params: RequestParams = {}) =>
      this.request<DeleteCategoryTranslationsResponse, Error>({
        path: `/category/translations.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateCategoryTranslations
     * @request POST:/category/translations.update
     * @secure
     */
    selfCareUpdateCategoryTranslations: (body: UpdateCategoryTranslationsRequest, params: RequestParams = {}) =>
      this.request<UpdateCategoryTranslationsResponse, Error>({
        path: `/category/translations.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  configurableShippingMethodsList = {
    /**
     * No description
     *
     * @name SelfCareListConfigurableShippingMethods
     * @request GET:/configurable_shipping_methods.list
     * @secure
     */
    selfCareListConfigurableShippingMethods: (params: RequestParams = {}) =>
      this.request<ListConfigurableShippingMethodsResponse, Error>({
        path: `/configurable_shipping_methods.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  configuration = {
    /**
     * No description
     *
     * @name SelfCareUpdateFaqWidgetDefaultConfiguration
     * @request POST:/configuration/faq
     * @secure
     */
    selfCareUpdateFaqWidgetDefaultConfiguration: (
      body: UpdateFaqWidgetDefaultConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateFaqWidgetDefaultConfigurationResponse, Error>({
        path: `/configuration/faq`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteFaqWidgetCountryConfiguration
     * @request POST:/configuration/faq/country.delete
     * @secure
     */
    selfCareDeleteFaqWidgetCountryConfiguration: (
      body: DeleteFaqWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteFaqWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/faq/country.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpsertFaqWidgetCountryConfiguration
     * @request POST:/configuration/faq/country.upsert
     * @secure
     */
    selfCareUpsertFaqWidgetCountryConfiguration: (
      body: UpsertFaqWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpsertFaqWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/faq/country.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateProductPageWidgetDefaultConfiguration
     * @request POST:/configuration/product_page
     * @secure
     */
    selfCareUpdateProductPageWidgetDefaultConfiguration: (
      body: UpdateProductPageWidgetDefaultConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateProductPageWidgetDefaultConfigurationResponse, Error>({
        path: `/configuration/product_page`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteProductPageWidgetCountryConfiguration
     * @request POST:/configuration/product_page/country.delete
     * @secure
     */
    selfCareDeleteProductPageWidgetCountryConfiguration: (
      body: DeleteProductPageWidgetCountryConfigurationReqeust,
      params: RequestParams = {},
    ) =>
      this.request<DeleteProductPageWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/product_page/country.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpsertProductPageWidgetCountryConfiguration
     * @request POST:/configuration/product_page/country.upsert
     * @secure
     */
    selfCareUpsertProductPageWidgetCountryConfiguration: (
      body: UpsertProductPageWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpsertProductPageWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/product_page/country.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpsertReceiptWidgetCountryConfiguration
     * @request POST:/configuration/receipt/country_configuration.upsert
     * @secure
     */
    selfCareUpsertReceiptWidgetCountryConfiguration: (
      body: UpsertReceiptWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpsertReceiptWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/receipt/country_configuration.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateReceiptWidgetDefaultConfiguration
     * @request POST:/configuration/receipt/default_configuration.update
     * @secure
     */
    selfCareUpdateReceiptWidgetDefaultConfiguration: (
      body: UpdateReceiptWidgetDefaultConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateReceiptWidgetDefaultConfigurationResponse, Error>({
        path: `/configuration/receipt/default_configuration.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateDeliveryUpsellWidgetConfiguration
     * @request POST:/configuration/upsell
     * @secure
     */
    selfCareUpdateDeliveryUpsellWidgetConfiguration: (
      body: UpdateDeliveryUpsellWidgetConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDeliveryUpsellWidgetConfigurationResponse, Error>({
        path: `/configuration/upsell`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateDeliveryUpsellWidgetCountryConfiguration
     * @request POST:/configuration/upsell/country.create
     * @secure
     */
    selfCareCreateDeliveryUpsellWidgetCountryConfiguration: (
      body: CreateDeliveryUpsellWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateDeliveryUpsellWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/upsell/country.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteDeliveryUpsellWidgetCountryConfiguration
     * @request POST:/configuration/upsell/country.delete
     * @secure
     */
    selfCareDeleteDeliveryUpsellWidgetCountryConfiguration: (
      body: DeleteDeliveryUpsellWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDeliveryUpsellWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/upsell/country.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateDeliveryUpsellWidgetCountryConfiguration
     * @request POST:/configuration/upsell/country.update
     * @secure
     */
    selfCareUpdateDeliveryUpsellWidgetCountryConfiguration: (
      body: UpdateDeliveryUpsellWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDeliveryUpsellWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/upsell/country.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateWidgetConfiguration
     * @request POST:/configuration/widget
     * @secure
     */
    selfCareUpdateWidgetConfiguration: (body: UpdateWidgetConfigurationRequest, params: RequestParams = {}) =>
      this.request<UpdateWidgetConfigurationResponse, Error>({
        path: `/configuration/widget`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateWidgetCountryConfiguration
     * @request POST:/configuration/widget/country.create
     * @secure
     */
    selfCareCreateWidgetCountryConfiguration: (
      body: CreateWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/widget/country.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteWidgetCountryConfiguration
     * @request POST:/configuration/widget/country.delete
     * @secure
     */
    selfCareDeleteWidgetCountryConfiguration: (
      body: DeleteWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/widget/country.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateWidgetCountryConfiguration
     * @request POST:/configuration/widget/country.update
     * @secure
     */
    selfCareUpdateWidgetCountryConfiguration: (
      body: UpdateWidgetCountryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateWidgetCountryConfigurationResponse, Error>({
        path: `/configuration/widget/country.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  configuredBookingMethodsList = {
    /**
 * No description
 *
 * @name SelfCareListConfiguredBookingMethods
 * @summary Return shipping methods configured for booking.
NOTE: endpoint can be used directly by merchants.
 * @request GET:/configured_booking_methods.list
 * @secure
 */
    selfCareListConfiguredBookingMethods: (params: RequestParams = {}) =>
      this.request<ListConfiguredBookingMethodsResponse, Error>({
        path: `/configured_booking_methods.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  configuredShippingMethodsList = {
    /**
     * No description
     *
     * @name SelfCareListConfiguredShippingMethods
     * @request GET:/configured_shipping_methods.list
     * @secure
     */
    selfCareListConfiguredShippingMethods: (params: RequestParams = {}) =>
      this.request<ListConfiguredShippingMethodsResponse, Error>({
        path: `/configured_shipping_methods.list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  configver = {
    /**
     * No description
     *
     * @name SelfCareListConfigurationChanges
     * @request GET:/configver/changes.list
     * @secure
     */
    selfCareListConfigurationChanges: (
      query?: {
        site_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListConfigurationChangesResponse, Error>({
        path: `/configver/changes.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customEventTypeDelete = {
    /**
     * No description
     *
     * @name SelfCareDeleteCustomEventType
     * @request POST:/custom_event_type.delete
     * @secure
     */
    selfCareDeleteCustomEventType: (body: DeleteCustomEventTypeRequest, params: RequestParams = {}) =>
      this.request<DeleteCustomEventTypeResponse, Error>({
        path: `/custom_event_type.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customEventTypeUpsert = {
    /**
     * No description
     *
     * @name SelfCareUpsertCustomEventType
     * @request POST:/custom_event_type.upsert
     * @secure
     */
    selfCareUpsertCustomEventType: (body: UpsertCustomEventTypeRequest, params: RequestParams = {}) =>
      this.request<UpsertCustomEventTypeResponse, Error>({
        path: `/custom_event_type.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customEventTypeTranslationDelete = {
    /**
     * No description
     *
     * @name SelfCareDeleteCustomEventTypeTranslation
     * @request POST:/custom_event_type_translation.delete
     * @secure
     */
    selfCareDeleteCustomEventTypeTranslation: (
      body: DeleteCustomEventTypeTranslationRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteCustomEventTypeTranslationResponse, Error>({
        path: `/custom_event_type_translation.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customEventTypeTranslationUpsert = {
    /**
     * No description
     *
     * @name SelfCareUpsertCustomEventTypeTranslation
     * @request POST:/custom_event_type_translation.upsert
     * @secure
     */
    selfCareUpsertCustomEventTypeTranslation: (
      body: UpsertCustomEventTypeTranslationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpsertCustomEventTypeTranslationResponse, Error>({
        path: `/custom_event_type_translation.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  deliveryNotificationSettings = {
    /**
     * No description
     *
     * @name SelfCareListProgressNotificationSettings
     * @summary ListProgressNotificationSettings - allows to list settings for notifications sent for progress updates of the tracking order.
     * @request GET:/delivery_notification_settings/progress.list
     * @secure
     */
    selfCareListProgressNotificationSettings: (
      query: {
        site_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListProgressNotificationSettingsResponse, Error>({
        path: `/delivery_notification_settings/progress.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareListSmartNotificationSettings
     * @request GET:/delivery_notification_settings/smart.list
     * @secure
     */
    selfCareListSmartNotificationSettings: (
      query: {
        site_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListSmartNotificationSettingsResponse, Error>({
        path: `/delivery_notification_settings/smart.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  internalEventType = {
    /**
     * No description
     *
     * @name SelfCareConfigureInternalEventType
     * @request POST:/internal_event_type
     * @secure
     */
    selfCareConfigureInternalEventType: (body: ConfigureInternalEventTypeRequest, params: RequestParams = {}) =>
      this.request<ConfigureInternalEventTypeResponse, Error>({
        path: `/internal_event_type`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchantCreate = {
    /**
     * No description
     *
     * @name SelfCareCreateMerchant
     * @request POST:/merchant.create
     * @secure
     */
    selfCareCreateMerchant: (body: CreateMerchantRequest, params: RequestParams = {}) =>
      this.request<CreateMerchantResponse, Error>({
        path: `/merchant.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchantRename = {
    /**
     * No description
     *
     * @name SelfCareRenameMerchant
     * @request POST:/merchant.rename
     * @secure
     */
    selfCareRenameMerchant: (body: RenameMerchantRequest, params: RequestParams = {}) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/merchant.rename`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  region = {
    /**
     * No description
     *
     * @name SelfCareCreateRegion
     * @request POST:/region/create
     * @secure
     */
    selfCareCreateRegion: (body: CreateRegionRequest, params: RequestParams = {}) =>
      this.request<CreateRegionResponse, Error>({
        path: `/region/create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteRegion
     * @request POST:/region/delete
     * @secure
     */
    selfCareDeleteRegion: (body: DeleteRegionRequest, params: RequestParams = {}) =>
      this.request<DeleteRegionResponse, Error>({
        path: `/region/delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateRegionDetails
     * @request POST:/region/details.update
     * @secure
     */
    selfCareUpdateRegionDetails: (body: UpdateRegionDetailsRequest, params: RequestParams = {}) =>
      this.request<UpdateRegionDetailsResponse, Error>({
        path: `/region/details.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateRegionProduct
     * @request POST:/region/product.create
     * @secure
     */
    selfCareCreateRegionProduct: (body: CreateRegionProductRequest, params: RequestParams = {}) =>
      this.request<CreateRegionProductResponse, Error>({
        path: `/region/product.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteRegionProduct
     * @request POST:/region/product.delete
     * @secure
     */
    selfCareDeleteRegionProduct: (body: DeleteRegionProductRequest, params: RequestParams = {}) =>
      this.request<DeleteRegionProductResponse, Error>({
        path: `/region/product.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateRegionProduct
     * @request POST:/region/product.update
     * @secure
     */
    selfCareUpdateRegionProduct: (body: UpdateRegionProductRequest, params: RequestParams = {}) =>
      this.request<UpdateRegionProductResponse, Error>({
        path: `/region/product.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateRegionProductFilerRules
     * @request POST:/region/product_filter_rules.update
     * @secure
     */
    selfCareUpdateRegionProductFilerRules: (body: UpdateRegionProductFilerRulesRequest, params: RequestParams = {}) =>
      this.request<UpdateSiteResponse, Error>({
        path: `/region/product_filter_rules.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateRegionProductPriceRules
     * @request POST:/region/product_price_rules.update
     * @secure
     */
    selfCareUpdateRegionProductPriceRules: (body: UpdateRegionProductPriceRulesRequest, params: RequestParams = {}) =>
      this.request<UpdateSiteResponse, Error>({
        path: `/region/product_price_rules.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  regionsList = {
    /**
     * No description
     *
     * @name SelfCareListRegions
     * @request GET:/regions.list
     * @secure
     */
    selfCareListRegions: (
      query?: {
        shipping_method?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListRegionsResponse, Error>({
        path: `/regions.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  serviceConfigurationCreate = {
    /**
     * No description
     *
     * @name SelfCareCreateServiceConfiguration
     * @request POST:/service_configuration.create
     * @secure
     */
    selfCareCreateServiceConfiguration: (body: CreateServiceConfigurationRequest, params: RequestParams = {}) =>
      this.request<CreateServiceConfigurationResponse, Error>({
        path: `/service_configuration.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  serviceConfigurationDelete = {
    /**
     * No description
     *
     * @name SelfCareDeleteServiceConfiguration
     * @request POST:/service_configuration.delete
     * @secure
     */
    selfCareDeleteServiceConfiguration: (body: DeleteServiceConfigurationRequest, params: RequestParams = {}) =>
      this.request<DeleteServiceConfigurationResponse, Error>({
        path: `/service_configuration.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  serviceConfigurationUpdate = {
    /**
     * No description
     *
     * @name SelfCareUpdateServiceConfiguration
     * @request POST:/service_configuration.update
     * @secure
     */
    selfCareUpdateServiceConfiguration: (body: UpdateServiceConfigurationRequest, params: RequestParams = {}) =>
      this.request<UpdateServiceConfigurationResponse, Error>({
        path: `/service_configuration.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shippingMethodConfigure = {
    /**
     * No description
     *
     * @name SelfCareConfigureShippingMethod
     * @request POST:/shipping_method.configure
     * @secure
     */
    selfCareConfigureShippingMethod: (body: ConfigureShippingMethodRequest, params: RequestParams = {}) =>
      this.request<ConfigureShippingMethodResponse, Error>({
        path: `/shipping_method.configure`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shippingMethodDeactivate = {
    /**
     * No description
     *
     * @name SelfCareDeactivateShippingMethod
     * @request POST:/shipping_method.deactivate
     * @secure
     */
    selfCareDeactivateShippingMethod: (body: DeactivateShippingMethodRequest, params: RequestParams = {}) =>
      this.request<DeactivateShippingMethodResponse, Error>({
        path: `/shipping_method.deactivate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shippingMethodConfigurationGet = {
    /**
     * No description
     *
     * @name SelfCareGetShippingMethodConfiguration
     * @request GET:/shipping_method_configuration.get
     * @secure
     */
    selfCareGetShippingMethodConfiguration: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShippingMethodConfigurationResponse, Error>({
        path: `/shipping_method_configuration.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shippingMethodsGet = {
    /**
     * No description
     *
     * @name SelfCareGetShippingMethod
     * @request GET:/shipping_methods.get
     * @secure
     */
    selfCareGetShippingMethod: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShippingMethodResponse, Error>({
        path: `/shipping_methods.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shippingMethodsList = {
    /**
     * No description
     *
     * @name SelfCareListShippingMethods
     * @request GET:/shipping_methods.list
     * @secure
     */
    selfCareListShippingMethods: (
      query: {
        /** SiteId specifies the site for which we are listing shipping methods. [required] */
        site_id: string;
        with_custom_booking_methods?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListShippingMethodsResponse, Error>({
        path: `/shipping_methods.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteCreate = {
    /**
     * No description
     *
     * @name SelfCareCreateSite
     * @request POST:/site.create
     * @secure
     */
    selfCareCreateSite: (body: CreateSiteRequest, params: RequestParams = {}) =>
      this.request<CreateSiteResponse, Error>({
        path: `/site.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteRename = {
    /**
     * No description
     *
     * @name SelfCareRenameSite
     * @request POST:/site.rename
     * @secure
     */
    selfCareRenameSite: (body: RenameSiteRequest, params: RequestParams = {}) =>
      this.request<RenameSiteResponse, Error>({
        path: `/site.rename`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sortingRulesList = {
    /**
     * No description
     *
     * @name SelfCareListSortingRules
     * @request POST:/sorting_rules.list
     * @secure
     */
    selfCareListSortingRules: (body: ListSortingRulesRequest, params: RequestParams = {}) =>
      this.request<ListSortingRulesResponse, Error>({
        path: `/sorting_rules.list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sortingRulesUpdate = {
    /**
     * No description
     *
     * @name SelfCareUpdateSortingRules
     * @request POST:/sorting_rules.update
     * @secure
     */
    selfCareUpdateSortingRules: (body: UpdateSortingRulesRequest, params: RequestParams = {}) =>
      this.request<UpdateSortingRulesResponse, Error>({
        path: `/sorting_rules.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggestedProductMappingsList = {
    /**
     * No description
     *
     * @name SelfCareListSuggestedCarrierProductsMappings
     * @request GET:/suggested_product_mappings.list
     * @secure
     */
    selfCareListSuggestedCarrierProductsMappings: (
      query?: {
        site_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListSuggestedCarrierProductMappingsResponse, Error>({
        path: `/suggested_product_mappings.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackingConfigStatusGet = {
    /**
     * No description
     *
     * @name SelfCareGetTrackingConfigStatus
     * @request GET:/tracking_config_status.get
     * @secure
     */
    selfCareGetTrackingConfigStatus: (
      query: {
        site_id: string;
        carrier_product_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTrackingConfigStatusResponse, Error>({
        path: `/tracking_config_status.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  trackingLinksForCarrierProductList = {
    /**
     * No description
     *
     * @name SelfCareListTrackingLinksForCarrierProduct
     * @request GET:/tracking_links_for_carrier_product.list
     * @secure
     */
    selfCareListTrackingLinksForCarrierProduct: (
      query?: {
        carrier_product_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListTrackingLinksForCarrierProductResponse, Error>({
        path: `/tracking_links_for_carrier_product.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  warehouse = {
    /**
     * No description
     *
     * @name SelfCareCreateWarehouse
     * @request POST:/warehouse/create
     * @secure
     */
    selfCareCreateWarehouse: (body: CreateWarehouseRequest, params: RequestParams = {}) =>
      this.request<CreateWarehouseResponse, Error>({
        path: `/warehouse/create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareCreateWarehouseCutoffTimes
     * @request POST:/warehouse/cutoffs.create
     * @secure
     */
    selfCareCreateWarehouseCutoffTimes: (body: CreateWarehouseCutoffTimesRequest, params: RequestParams = {}) =>
      this.request<CreateWarehouseCutoffTimesResponse, Error>({
        path: `/warehouse/cutoffs.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteWarehouseCutoffTimes
     * @request POST:/warehouse/cutoffs.delete
     * @secure
     */
    selfCareDeleteWarehouseCutoffTimes: (body: DeleteWarehouseCutoffTimesRequest, params: RequestParams = {}) =>
      this.request<DeleteWarehouseCutoffTimesResponse, Error>({
        path: `/warehouse/cutoffs.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateWarehouseCutoffTimes
     * @request POST:/warehouse/cutoffs.update
     * @secure
     */
    selfCareUpdateWarehouseCutoffTimes: (body: UpdateWarehouseCutoffTimesRequest, params: RequestParams = {}) =>
      this.request<UpdateWarehouseCutoffTimesResponse, Error>({
        path: `/warehouse/cutoffs.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteWarehouse
     * @request POST:/warehouse/delete
     * @secure
     */
    selfCareDeleteWarehouse: (body: DeleteWarehouseRequest, params: RequestParams = {}) =>
      this.request<DeleteWarehouseResponse, Error>({
        path: `/warehouse/delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareUpdateWarehouseDetails
     * @request POST:/warehouse/details.update
     * @secure
     */
    selfCareUpdateWarehouseDetails: (body: UpdateWarehouseDetailsRequest, params: RequestParams = {}) =>
      this.request<UpdateWarehouseDetailsResponse, Error>({
        path: `/warehouse/details.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareDeleteWarehouseShippingDateAdjustment
     * @request POST:/warehouse/shipping_date_adjustment.delete
     * @secure
     */
    selfCareDeleteWarehouseShippingDateAdjustment: (
      body: DeleteWarehouseShippingDateAdjustmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteWarehouseShippingDateAdjustmentResponse, Error>({
        path: `/warehouse/shipping_date_adjustment.delete`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SelfCareSetWarehouseShippingDateAdjustment
     * @request POST:/warehouse/shipping_date_adjustment.set
     * @secure
     */
    selfCareSetWarehouseShippingDateAdjustment: (
      body: SetWarehouseShippingDateAdjustmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<SetWarehouseShippingDateAdjustmentResponse, Error>({
        path: `/warehouse/shipping_date_adjustment.set`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
